import commonCountryEn from "./common/country/default";
import commonCurrencyEn from "./common/currency/default";
import { commonDateEn } from "./common/date/default";
import componentsComboboxEn from "./components/combobox/default";
import componentsDataTableEn from "./components/data-table/default";
import componentsFlowNodeEn from "./components/flow-node/default";
import componentsFormAddressFormEn from "./components/form/address-form/default";
import { componentsFormFileItemEn } from "./components/form/file-item/default";
import pagesContractorCoreEn from "./contractor-core";
import domainAppUserEn from "./features/app-user/default";
import boeTaskEn from "./features/boe-task/default";
import domainDeviceEn from "./features/device/default";
import formFactoryEn from "./features/form-factory/default";
import operationArchivesEn from "./features/operation-archives/default";
import operationPackageConfigEn from "./features/operation-package-config/default";
import operationPackageInstanceEn from "./features/operation-package-instance/default";
import operationPackageEn from "./features/operation-package/default";
import domainPersonEn from "./features/person/default";
import domainQrScannerEn from "./features/qr-scanner/default";
import domainWorkerTypeRuleEn from "./features/worker-type-rule/default";
import pagesGAOperationCoreEn from "./ga-operation-core";
import individualPagesEn from "./individual-pages";
import pagesLaborCoreEn from "./labor-core";
import pagesAppsOrgSettingsEn from "./pages/apps/org-settings/default";
import pagesAuthEn from "./pages/auth/default";
import pagesCertificationEn from "./pages/certification/default";
import pagesCockpitEn from "./pages/cockpit/default";
import { pagesContractEn } from "./pages/contract/contract";
import { pagesContractListEn } from "./pages/contract/list";
import pagesDevicesAddEn from "./pages/devices/add/default";
import pagesDevicesExternalItSaasEn from "./pages/devices/external-it-saas/default";
import pagesDevicesFileEn from "./pages/devices/file/default";
import { pagesEquipmentEn } from "./pages/equipment/equipment";
import { pagesFleetsEn } from "./pages/fleets/fleet";
import { pagesIdManagementsEn } from "./pages/id-managements/idManagement";
import { pagesITOperationCoreEn } from "./pages/it-operation-core/default";
import pagesLicensesEn from "./pages/licenses/default";
import pagesMarketplaceEn from "./pages/marketplace/default";
import pagesNetworksEn from "./pages/networks/default";
import pagesOrganizationEn from "./pages/organization/default";
import pagesPeopleSettingsEn from "./pages/people/settings/default";
import pagesPersonExternalHrSaasEn from "./pages/person/external-hr-saas/default";
import pagesPersonImportCsvEn from "./pages/person/import-csv/default";
import { pagesPlacesEn } from "./pages/places/places";
import pagesProfileAppIdRuleAndPolicyEn from "./pages/profile/app/rule-and-policy/default";
import { pagesPublicIdsEn } from "./pages/public-ids/default";
import pagesSettingsPermissionAndRolesEn from "./pages/settings/permission-and-roles/default";
import pagesSettingsPersonsEn from "./pages/settings/persons/default";
import pagesSettingsSettingsEn from "./pages/settings/settings/default";
import pagesStarlinksEn from "./pages/starlinks/default";
import { pagesTimeAndAttendanceEn } from "./pages/time-and-attendance/timeAndAttendance";
import pagesVendorMarketplaceEn from "./pages/vendor/marketplace/default";

const en = {
  pages: {
    accountSettings: {
      title: "Account Settings",
      email: "Email",
      changingEmailNotSupported: "Changing email is not supported yet",
      password: "Password",
      changePasswordButton: "Change password",
      language: "Language",
      changeLanguageTitle: "Changing to {{target}}",
      changeLanguageDescription:
        "After you confirm, the page will reload and display the interface in the {{target}}.",
      cancel: "Cancel",
      changeLanguage: "Change language",
      changePasswordTitle: "Change Password",
      changePasswordDescription:
        "Password must be 10 letters long with both letters and numbers and special characters (e.g. ^$*.[]{}()?\"!@#%&/\\,><':;|_~`=+-)",
      currentPassword: "Current Password",
      currentPasswordPlaceholder: "Enter current password",
      newPassword: "New Password",
      newPasswordPlaceholder: "Enter new password",
      confirmNewPassword: "Confirm New Password",
      confirmNewPasswordPlaceholder: "Enter new password again",
      changePassword: "Change Password",
      showPassword: "Show password",
      errorRequired: "This field is required",
      errorInvalidPassword:
        "Password must be 10 letters long with both letters and numbers and special characters (e.g. ^$*.[]{}()?\"!@#%&/\\,><':;|_~`=+-)",
      errorPasswordNotMatch: "Passwords do not match",
      messagePasswordChangedSuccessfully: "🎉 Password changed successfully",
      messagePasswordIsInvalid: "Password is invalid",
      messageChangePasswordLimitExceeded:
        "😅 Password change limit exceeded, please try after some time",
      messagePasswordIsIncorrect: "Password is incorrect",
      messageFailedToChangePassword: "😣 Failed to change password",
      signOutButton: "Sign out",
      confirmDescription: "You will be directed to the sign in page.",
      confirmSignOutButton: "Sign out",
      confirmSignOutTitle: "Signing out of {{accountName}}",
    },
    apps: {
      title: "Software",
      marketplace: {
        pageTitle: "software - Add Integration",
        title: "Software",
        addIntegrationTitle: "Add Integration",
        requestIntegration: "Request Integration",
        searchAppPlaceholder: "Search for software",
        searchAppAllCategories: "All",
        notFound: "Sorry, No Software Found.",
        addCustomApp: "Add Custom SaaS",
        addIntegrationAsCustomApp: "Add integration as custom SaaS",
        detailPage: {
          pageTitle: "software/${{name}}",
          backButton: "Add Integration",
          startIntegrationButton: "Start integration",
          information: "You will need the following information to integrate",
          authorizationInfo: "Authorization Information",
          contractInfo: "Contract Information",
          availablePlans: "Requires {{value}}", // ex: Requires Free, Pro
          allPlanAvailable: "Requires All Plan",
          category: "Category",
          website: "Website",
          functionsGridTitle: "What you can do",
          functions: {
            userList: "List all users",
            userCreate: "Create users",
            userDeactivate: "Deactivate users",
            manageUserGroups: "Manage user groups",
          },
        },
        installAppDialog: {
          title: "Integrate to {{appName}}",
          description:
            "Fill in the items below to bring the best out of the integration.",
          authentication: {
            label: "Authentication",
            placeholder: "Select Auth Method",
          },
          pricingPlan: {
            label: "Pricing Plan",
            placeholder: "Select Plan",
          },
          useCustomPrice: "Use custom price",
          subscription: {
            label: "Subscription",
            placeholder: "Select Subscription",
          },
          licenseSeat: {
            label: "License Seat",
            placeholder: "e.g. 5",
          },
          currency: {
            label: "Currency",
            placeholder: "Select currency",
          },
          contractAnchor: {
            label: "Contract renewal date",
            monthDayFormat: "<day/> / <month/>",
            month: {
              placeholder: "Select month",
            },
            day: {
              placeholder: "Select day",
            },
          },
          submitButton: "Continue to {{appName}}",
          error: {
            appDetailsNotFound: "Software details not found",
          },
        },
        failedInstall: "Failed to Authorized To {{appName}}",
        failedToInstallDialog: {
          title: "Failed to integrate {{appName}}",
          tryAgainButton: "Try again",
          goBackButton: "Go back",
        },
      },
      customApp: {
        category: {
          communication: "Communication",
          design: "Design",
          development: "Development",
          storage: "Storage",
          finance_and_accounting: "Finance and Accounting",
          general_affairs: "General Affairs",
          human_resources: "Human Resources",
          it_security: "IT Security",
          legal: "Legal",
          marketing: "Marketing",
          project_management: "Project Management",
          sales_crm: "Sales CRM",
        },
        billingCycle: {
          month: "Monthly",
          year: "Yearly",
        },
        add: {
          intro: {
            header: {
              headerTitle: "Add Custom SaaS",
            },
          },
          itemCard: {
            title_custom_app: "Custom SaaS",
            requiredDetails: "Required Details",
          },
          selectCustomAppType: "Select Type",
          fillOutDetails: "Fill out details",
          form: {
            navigation: {
              title: {
                custom_app: "Add custom SaaS",
              },
              common: {
                submitButtonLabel: "Add custom SaaS",
              },
              step: {
                one: "Define custom SaaS",
                two: "Register plan details",
                three: "Format user properties",
              },
              intro: {
                customAppNameLabel: "Custom SaaS Name",
                appCategoryLabel: "Software Category",
                pricingLabel: "Pricing",
                nameLabel: "Name",
                categoryLabel: "Category",
              },
              step1: {
                title: "Define custom SaaS",
                customAppNameLabel: "Custom SaaS Name",
                customAppNamePlaceholder: "Enter custom SaaS name",
                supplements: "Supplements",
                appServiceUrlLabel: "Software Service URL",
                appServiceUrlPlaceholder: "Type URL",
                appCategoryLabel: "Software Category",
                appCategoryPlaceholder: "Select Category...",
                appLogoLabel: "Software Logo",
                fileSizeError: "File size must be less than 1MB",
                tenantNameLabel: "Tenant Name",
                tenantNamePlaceholder: "Enter tenant name",
                tenantNameTooltip: `This name is used to identify your company or organization.
Names already in use within the same software cannot be used.`,
                appSuggestDescription: "Might it be…",
              },
              step2: {
                planNameLabel: "Plan Name",
                planNamePlaceholder: "Enter plan name",
                pricingLabel: "Pricing",
                freePlanLabel: "Free",
                usageBasedPlanLabel:
                  "Usage based pricing (ex. per user, per license)",
                fixedPricePlanLabel: "Fixed price",
                planOption: {
                  billingCycleLabel: "Billing cycle",
                  billingCycleDescription:
                    "The recurring time period between billings for a subscription or service.",
                  billingCyclePlaceholder: "Select billing cycle...",
                  billingAnchorDateLabel: "Billing anchor date",
                  billingAnchorDateDescription:
                    "A billing anchor date is the specific day of the billing anchor date when recurring charges are processed. ",
                  billingAnchorDatePlaceholder: "Anchor date",
                  currencyLabel: "Currency",
                  currencyPlaceholder: "Select currency...",
                  unitRateLabel: "Unit rate",
                  unitRateDescription:
                    "The cost or price per individual usage unit.",
                  unitRatePlaceholder: "Type number",
                  costLabel: "The cost or price per individual usage unit.",
                  typeNumber: "Type number",
                  priceLabel: "Price",
                },
                licenseLabel: "License",
                licenseBasedLabel: "License based",
                notLicenseBasedLabel: "Not license based",
                licenseOption: {
                  sheetLimitLabel: "Sheet limit",
                  sheetLimitPlaceholder: "Type number",
                },
              },
              completeDialog: {
                message: "Successfully added custom SaaS!",
                completeLinkButton: "Continue to import user account data",
                additionalButton: "Go to software details",
              },
            },
          },
        },
        importCsv: {
          navigation: {
            title: "Import {{appName}}'s user account",
            newUser: "New user",
            updateExistingUser: "Update existing user",
          },
          completeDialog: {
            message: "Successfully imported!",
            button: "Go to software details",
          },
          checkValidColumn: {
            errors: "Errors",
          },
        },
      },
      overview: {
        pageTitle: "software/overview",
        cards: {
          integrationsCard: {
            title: "Integrations",
            unit: "software",
            label: "New software from last month",
          },
          usersCard: {
            title: "Users",
            unit: "users",
          },
          inactiveUsersCard: {
            title: "Inactive Users",
            unit: "users",
          },
          upcomingRenewalsCard: {
            title: "Upcoming Renewals",
            unit: "in {{value}}",
          },
          peopleCard: {
            title: "People",
            unit: "persons",
            noDepartment: "(No department)",
          },
          monthlyBillingByDeptCard: {
            title: "Monthly Billing By Dept",
            emptyDepartment: "(No department)",
          },
          monthlyBillingByAppCard: {
            title: "Monthly Billing By Software",
          },
          potentialSavingsCard: {
            title: "Potential Savings",
            unit: "per month",
          },
          scheduledOperation: {
            title: "Scheduled Operation",
            todayAnnouncement: "Today: {{value}} persons are joining!",
            weekAnnouncement: "This week: {{value}} persons are joining!",
            viewMore: "View more",
          },
          recentActivityCard: {
            title: "Recent Activity",
            activity:
              "<executor /> created the <software /> user account of <target />.",
            viewMore: "View more",
          },
        },
      },
      integrations: {
        pageTitle: "software/integrations",
        title: "Integrations",
        tabs: {
          integrations: "Integrations",
          customApps: "Custom SaaS",
          all: "All",
          deactivated: "Deactivated",
        },
        filters: {
          contractRenewalDate:
            "Contract Renewal Date <light>is</light> in this month",
          statusSearchPlaceholder: "Search for status...",
          roleSearchPlaceholder: "Search for role...",
        },
        columns: {
          pricingModel: {
            UNPREDICTABLE: "Unpredictable",
            FREE: "Free",
            LINEAR: "Linear",
            FIXED: "Fixed",
            HARDCODED: "Unique",
          },
          renewalDate: {
            renewalDateIsWithinOneMonth: "Renewal date is within one month",
          },
          deleteDialog: {
            title: "Delete {{name}}?",
            description:
              "{{name}}'s account will be deleted. This action cannot be undone.",
            successToast: "Account deleted successfully",
          },
          app: {
            noTenantName: "(No tenant name)",
          },
        },
        monthOverMonth: "MoM",
        addIntegrationButton: "Add Integration",
        filterIntegrationPlaceholder: "Filter Software...",
        changePerson: "Change Person",
        assignPerson: "Assign Person",
        delete: "Delete",
        actions: {
          refresh: "Sync",
        },
        status: {
          refresh: {
            inProgress: "Sync in progress",
            lastFailed: "Last sync failed",
          },
        },
        toast: {
          refresh: {
            triggered: "Sync started",
            alreadyInProgress: "Already in progress",
            rateLimited: "Rate limited",
          },
        },
      },
      people: {
        pageTitle: "software/people",
        filterPeoplePlaceholder: "Filter by name...",
        tabs: {
          joined: "Joined",
          joining: "Joining",
          leaving: "Leaving",
          all: "All",
        },
        columns: {
          details: "Details",
          showProfile: "Show Profile",
          noApps: "No software",
          noDevices: "No devices",
        },
        cards: {
          goToProfile: "Go To Profile",
        },
        filters: {
          app: "Software",
          hasSomeApp: "Has Some Software",
          appCount: "Software Count",
          equalTo: "equals to",
          moreThan: "more than",
          lessThan: "less than",
          isMoreThan: "is more than",
          isLessThan: "is less than",
          model: "Model",
          selected: "{{value}} selected",
          locationOfOffice: "Location Of Office",
          filterLocationPlaceholder: "Filter location...",
          appPlaceholder: "Search for software",
          noResult: "No results.",
          workerTypePlaceholder: "Search for worker types",
          placePlaceholder: "Search for work place",
          quantityFilterOutput: "{{label}} <light>{{text}}</light> {{amount}}",
          filterOutput: "{{label}} <light>is</light> {{name}}",
        },
      },
      alert: {
        pageTitle: "software/alerts",
        filter: {
          freeText: "Filter people...",
          byApp: {
            name: "Software",
            predicate: "is",
            searchPlaceholder: "Search software...",
            notFound: "No software found",
          },
          toggleSummary: "Show summary",
        },
        tabs: {
          shadowIt: "Shadow IT",
          noWorker: "Unidentified",
          violatedAssignment: "Violated Assignment",
          violatedRole: "Violated Account Role",
          noUser: "No User",
          inactive: "Inactive",
        },
        help: {
          shadowIt: {
            title: "Shadow IT?",
            text: "Shadow IT refers to the access to software not integrated to DRESS CODE. DRESS CODE collects access logs via the browser extension twice a day and every 12 hours.<br />(The data from 0:00 to 11:00 on the previous day is updated at 7:00 on the current day / The data from 12:00 to 23:00 on the previous day is updated at 19:00 on the current day.)",
          },
          unidentified: {
            title: "Unidentified?",
            text: "Unidentified refers to a user account that is not linked to any person. The account is linked by either changing the account’s email to match or assigning a person to the account",
          },
          violatedAssignment: {
            title: "Violated Assignment?",
            text: "Violated assignment refers to user accounts that exist despite not being permitted under the user assignment rules.",
          },
          violatedAccountRole: {
            title: "Violated Account Role?",
            text: "User accounts with roles that do not align with the assignment rule.",
          },
          noUser: {
            title: "No User?",
            text: "No User lists people who should have been issued user accounts but currently do not have them.",
          },
          inactive: {
            title: "Inactive?",
            text: "Inactive refers to accounts that have no activity for more than 20 days. The detection of inactive accounts is only applicable to software that track last-usage timestamps.",
          },
        },
        shadowIt: {
          title: "Shadow IT",
          details: "Shadow IT details",
          shadowId: "Shadow ID",
          apps: {
            freeText: "Filter software...",
            showDetail: "Show detail",
            integrate: "Integrate",
            createCustomApp: "Integrate as custom SaaS",
          },
          visitHistories: {
            freeText: "Filter person by name, email...",
          },
          integrateAsCustomApp: "Integrate as custom SaaS",
        },
        appCard: {
          goToProfile: "Go To Profile",
        },
        actions: {
          openMenu: "Open menu",
          editRole: "Edit Role",
        },
      },
      orgSettings: pagesAppsOrgSettingsEn,
    },
    auth: pagesAuthEn,
    department: {
      title: "Department",
      list: {
        pageTitle: "department/list",
        searchInputPlaceholder: "Filter department...",
      },
    },
    laborCore: pagesLaborCoreEn,
    contractorCore: pagesContractorCoreEn,
    gaOperationCore: pagesGAOperationCoreEn,
    itOperationCore: pagesITOperationCoreEn,
    marketplace: pagesMarketplaceEn,
    organization: pagesOrganizationEn,
    cockpit: pagesCockpitEn,
    contract: {
      ...pagesContractEn,
      list: pagesContractListEn,
    },
    settings: {
      persons: pagesSettingsPersonsEn,
      settings: pagesSettingsSettingsEn,
      permissionAndRoles: pagesSettingsPermissionAndRolesEn,
    },
    software: {
      profile: {
        detail: {
          navigation: {
            softwareIdInformation: "Software ID Information",
            link: "Link",
            responsibility: "Responsibility",
            vendor: "Vendor",
            maintenanceSupport: "Maintenance & Support",
            provisioningDistribution: "Provisioning & Distribution",
            compatibilityEnvironment: "Compatibility & Environment",
            securityCompliance: "Security & Compliance",
            operationalStatus: "Operational Status",
          },
          sections: {
            softwareIdInformation: {
              pageTitle: "Software ID Information",
              softwareId: "Software ID",
              softwareName: "Software Name",
              softwareAlias: "Software Alias",
              softwareType: "Software Type",
              category: "Category",
              description: "Description",
              logo: "Logo",
            },
            link: {
              pageTitle: "Link",
              servicePageUrl: "Service Page URL",
              termsOfUseUrl: "Terms Of Use URL",
              privacyPolicyUrl: "Privacy Policy URL",
              pricingPageUrl: "Pricing Page URL",
            },
            responsibility: {
              pageTitle: "Responsibility",
              responsiblePersonId: "Responsible Person ID",
              responsiblePersonName: "Responsible Person Name",
              responsibleDepartment: "Responsible Department",
            },
            vendor: {
              pageTitle: "Vendor",
              vendorId: "Vendor ID",
              vendorName: "Vendor Name",
              vendorContact: "Vendor Contact",
              vendorUrl: "Vendor URL",
            },
            maintenanceSupport: {
              pageTitle: "Maintenance & Support",
              supportLevel: "Support Level",
              updateFrequency: "Update Frequency",
            },
            provisioningDistribution: {
              pageTitle: "Provisioning & Distribution",
              deploymentMethod: "Deployment Method",
              platformUsage: "Platform Usage",
              linkedDeviceId: "Linked Device ID",
              linkedSoftwareId: "Linked Software ID",
              mdmManaged: "MDM managed",
            },
            compatibilityEnvironment: {
              pageTitle: "Compatibility & Environment",
              requiredOs: "Required OS",
              compatibleBrowsers: "Compatible Browsers",
              supportedLanguages: "Supported Languages",
            },
            securityCompliance: {
              pageTitle: "Security & Compliance",
              securityCertifications: "Security Certifications",
              dataLocation: "Data Location",
              gdprCompliance: "GDPR Compliance",
              accessControlType: "Access Control Type",
            },
            operationalStatus: {
              pageTitle: "Operational Status",
              usageStatus: "Usage Status",
              retirementDate: "Retirement Date",
            },
          },
        },
        architecture: {
          pageTitle: "Architecture",
          navigation: {
            versionBuildInformation: "Version/Build Information",
            softwareComponent: "Software Component",
            softwareDependency: "Software Dependency",
            softwareInstance: "Software Instance",
            installInformation: "Install Information",
            executionRequirements: "Execution Requirements",
            securityCompliance: "Security & Compliance",
            uninstallInformation: "Uninstall Information",
          },
          sections: {
            versionBuildInformation: {
              pageTitle: "Version/Build Information",
              version: "Version",
              buildNumber: "Build Number",
              releaseDate: "Release Date",
              patchStatus: "Patch Status",
              patchVersion: "Patch Version",
              endOfSupportDate: "End of Support Date",
              versionPolicy: "Version Policy",
            },
            softwareComponent: {
              pageTitle: "Software Component",
              componentId: "Component ID",
              componentName: "Component Name",
              repositoryUrl: "Repository URL",
              runtime: "Runtime",
            },
            softwareDependency: {
              pageTitle: "Software Dependency",
              dependencyId: "Dependency ID",
              dependsOnType: "Depends on Type",
              dependsOnId: "Depends on ID",
              minVersion: "Min Version",
              maxVersion: "Max Version",
              requiredFlag: "Required Flag",
            },
            softwareInstance: {
              pageTitle: "Software Instance",
              instanceId: "Instance ID",
              instanceType: "Instance Type",
              tenantDomain: "Tenant Domain",
              environment: "Environment",
              region: "Region",
              linkedSystems: "Linked Systems",
            },
            installInformation: {
              pageTitle: "Install Information",
              installationDate: "Installation Date",
              installationPath: "Installation Path",
              installationMethod: "Installation Method",
              installationMediaInfo: "Installation Media Info",
              installedDevicesCount: "Installed Devices Count",
            },
            executionRequirements: {
              pageTitle: "Execution Requirements",
              requiredMemory: "Required Memory",
              requiredDiskSpace: "Required Disk Space",
              dependentSoftware: "Dependent Software",
              executionMode: "Execution Mode",
            },
            securityCompliance: {
              pageTitle: "Security & Compliance",
              requiresAdminPrivilege: "Requires Admin Privilege",
              autoUpdateSetting: "Auto Update Setting",
              updateServerUrl: "Update Server URL",
              tamperDetectionEnabled: "Tamper Detection Enabled",
            },
            uninstallInformation: {
              pageTitle: "Uninstall Information",
              uninstallationDate: "Uninstallation Date",
              uninstallationMethod: "Uninstallation Method",
              uninstalledBy: "Uninstalled by",
              uninstallationReason: "Uninstallation Reason",
            },
          },
        },
        contractsCost: {
          pageTitle: "Contracts & Cost",
          navigation: {
            contractInformation: "Contract Information",
            planInformation: "Plan Information",
            budgetCost: "Budget & Cost",
          },
          sections: {
            contractInformation: {
              pageTitle: "Contract Information",
              contractId: "Contract ID",
              contractName: "Contract Name",
              contractType: "Contract Type",
              contractStatus: "Contract Status",
              contractStartDate: "Contract Start Date",
              contractEndDate: "Contract End Date",
              autoRenew: "Auto Renew",
              renewalWindow: "Renewal Window",
              cancellationDeadline: "Cancellation Deadline",
              noticePeriod: "Notice Period",
              contractAmount: "Contract Amount",
              billingCycle: "Billing Cycle",
              paymentMethod: "Payment Method",
              paymentTerms: "Payment Terms",
              paymentCurrency: "Payment Currency",
              supplierId: "Supplier ID",
              supplierContact: "Supplier Contact",
              contractFileUrl: "Contract File URL",
              contractNotes: "Contract Notes",
            },
            planInformation: {
              pageTitle: "Plan Information",
              planId: "Plan ID",
              planName: "Plan Name",
              planCode: "Plan Code",
              planType: "Plan Type",
              pricingModel: "Pricing Model",
              pricingDriver: "Pricing Driver",
              currency: "Currency",
              unitPrice: "Unit Price",
              baseFee: "Base Fee",
              variableFee: "Variable Fee",
              usageUnit: "Usage Unit",
              usageLimit: "Usage Limit",
              includedFeatures: "Included Features",
              planNotes: "Plan Notes",
            },
            budgetCost: {
              pageTitle: "Budget & Cost",
              costMonth: "Cost Month",
              budgetedCost: "Budgeted Cost",
              actualCost: "Actual Cost",
              varianceReason: "Variance Reason",
              costCenter: "Cost Center",
              invoiceNumber: "Invoice Number",
              taxRate: "Tax Rate",
            },
          },
        },
        activityMonitoring: {
          pageTitle: "Activity Monitoring",
          navigation: {
            accountAccessActivity: "Account Access Activity",
            accountAccessAudit: "Account Access Audit",
          },
          sections: {
            accountAccessActivity: {
              pageTitle: "Account Access Activity",
              table: {
                accountId: "Account ID",
                activityType: "Activity Type",
                activityDescription: "Activity Description",
                deviceId: "Device ID",
                ipAddress: "IP Address",
              },
            },
            accountAccessAudit: {
              pageTitle: "Account Access Audit",
              auditReviewStatus: "Audit Review Status",
              reviewedBy: "Reviewed by",
              reviewedAt: "Reviewed at",
            },
          },
        },
      },
      alert: {
        pageTitle: "software/alerts",
        bulkProvision: "Bulk Provision",
        bulkDeactivation: "Bulk Deactivation",
        errors: {
          packageNotFound: "Package not found",
        },
        filter: {
          freeText: "Filter people...",
          byApp: {
            name: "Software",
            predicate: "is",
            searchPlaceholder: "Search software...",
            notFound: "No software found",
          },
          toggleSummary: "Show summary",
        },
        tabs: {
          shadowIt: "Shadow IT",
          noWorker: "Unidentified",
          violatedAssignment: "Violated Assignment",
          violatedRole: "Violated Account Role",
          noUser: "No User",
          inactive: "Inactive",
          alumni: "Alumni's",
        },
        help: {
          shadowIt: {
            title: "Shadow IT?",
            text: "Shadow IT refers to the access to software not integrated to DRESS CODE. DRESS CODE collects access logs via the browser extension twice a day and every 12 hours.<br />(The data from 0:00 to 11:00 on the previous day is updated at 7:00 on the current day / The data from 12:00 to 23:00 on the previous day is updated at 19:00 on the current day.)",
          },
          unidentified: {
            title: "Unidentified?",
            text: "Unidentified refers to a user account that is not linked to any person. The account is linked by either changing the account's email to match or assigning a person to the account",
          },
          violatedAssignment: {
            title: "Violated Assignment?",
            text: "Violated assignment refers to user accounts that exist despite not being permitted under the user assignment rules.",
          },
          violatedAccountRole: {
            title: "Violated Account Role?",
            text: "User accounts with roles that do not align with the assignment rule.",
          },
          noUser: {
            title: "No User?",
            text: "No User lists people who should have been issued user accounts but currently do not have them.",
          },
          inactive: {
            title: "Inactive?",
            text: "Inactive refers to accounts that have no activity for more than 20 days. The detection of inactive accounts is only applicable to software that track last-usage timestamps.",
          },
          alumni: {
            title: "Alumni?",
            text: "Accounts associated with former employees who have left the company.<br />Regular review and account deletion is recommended to avoid security risks.",
          },
        },
        shadowIt: {
          title: "Shadow IT",
          details: "Shadow IT details",
          shadowId: "Shadow ID",
          apps: {
            freeText: "Filter software...",
            showDetail: "Show detail",
            integrate: "Integrate",
            createCustomApp: "Integrate as custom SaaS",
          },
          visitHistories: {
            freeText: "Filter person by name, email...",
          },
          integrateAsCustomApp: "Integrate as custom SaaS",
        },
        appCard: {
          goToProfile: "Go To Profile",
        },
        actions: {
          openMenu: "Open menu",
          editRole: "Edit Role",
        },
      },
      integrations: {
        status: {
          refresh: {
            inProgress: "Refresh in progress...",
          },
        },
        toast: {
          refresh: {
            triggered: "Refresh triggered successfully",
            alreadyInProgress: "Refresh already in progress",
            rateLimited: "Rate limited, please try again later",
          },
        },
        actions: {
          refresh: "Sync",
        },
      },
      productHeader: {
        pageTitle: "Software",
      },
      marketplace: {
        pageTitle: "Marketplace",
        title: "Marketplace",
        requestIntegration: "Request",
        addIntegrationTitle: "Add SaaS Integration",
        searchAppPlaceholder: "Search by SaaS name",
        searchAppAllCategories: "All",
        notFound: "Sorry, integration for this SaaS is not yet supported.",
        addCustomApp: "Add Custom SaaS",
        addIntegrationAsCustomApp: "Integrate as Custom SaaS",
        detailPage: {
          pageTitle: "Marketplace / {{name}}",
          backButton: "Marketplace",
          startIntegrationButton: "Integrate",
          information: "The following information is required for integration",
          authorizationInfo: "Authentication Information",
          contractInfo: "Contract Information",
          availablePlans: "Available pricing plans: {{value}}",
          allPlanAvailable: "Available pricing plans: All",
          category: "Category",
          website: "Website",
          functionsGridTitle: "Available Functions",
          functions: {
            userList: "Account Visibility",
            userCreate: "Account Creation",
            userDeactivate: "Account Deactivation",
            manageUserGroups: "User Group Management",
          },
        },
        installAppDialog: {
          title: "Integrate {{appName}}",
          description: "Fill in the following items to start SaaS integration!",
          authentication: {
            title: "Authentication Information",
            description:
              "Enter the authentication information required for SaaS integration.",
          },
          contract: {
            title: "Contract Information",
            description: "Enter contract-related information.",
          },
          pricingPlan: {
            title: "Pricing Plan",
            description: "Select the pricing plan to use.",
          },
          contractAnchor: {
            title: "Contract Start Date",
            description: "Set the contract start date.",
          },
          installButton: "Start Integration",
          cancelButton: "Cancel",
        },
      },
      customSaas: {
        category: {
          communication: "Communication",
          design: "Design",
          development: "Development",
          storage: "Storage",
          finance_and_accounting: "Finance & Accounting",
          general_affairs: "General Affairs",
          human_resources: "Human Resources",
          it_security: "IT Security",
          legal: "Legal",
          marketing: "Marketing",
          project_management: "Project Management",
          sales_crm: "Sales & CRM",
        },
        add: {
          itemCard: {
            title_custom_saas: "Custom SaaS",
            requiredDetails: "Required Details",
          },
          selectCustomSaasType: "Select Type",
          fillOutDetails: "Fill Out Details",
          intro: {
            header: {
              headerTitle: "Add Custom SaaS",
            },
          },
          form: {
            navigation: {
              title: "Add Custom SaaS",
              common: {
                submitButtonLabel: "Add Custom SaaS",
              },
              step: {
                one: "Define Custom SaaS",
                two: "Register plan details",
              },
              intro: {
                customSaasNameLabel: "Custom SaaS Name",
                saasCategoryLabel: "SaaS Category",
                pricingLabel: "Pricing",
                nameLabel: "Name",
              },
              step1: {
                title: "Define Custom SaaS",
                customSaasNameLabel: "Custom SaaS Name",
                customSaasNamePlaceholder: "Enter custom SaaS name",
                supplements: "Additional Information",
                saasServiceUrlLabel: "SaaS Service URL",
                saasServiceUrlPlaceholder: "Enter URL",
                saasCategoryLabel: "SaaS Category",
                saasCategoryPlaceholder: "Select Category...",
                saasLogoLabel: "SaaS Logo",
                fileSizeError: "File size must be less than 1MB",
                tenantNameLabel: "Tenant Name",
                tenantNamePlaceholder: "Enter tenant name",
                tenantNameTooltip: `This name is used to identify your company or organization.
Names already in use within the same software cannot be used.`,
                saasSuggestDescription: "Might it be…",
              },
              step2: {
                planNameLabel: "Plan Name",
                planNamePlaceholder: "Enter plan name",
                pricingLabel: "Pricing",
                freePlanLabel: "Free",
                usageBasedPlanLabel:
                  "Usage based pricing (ex. per user, per license)",
                fixedPricePlanLabel: "Fixed price",
                planOption: {
                  billingCycleLabel: "Billing cycle",
                  billingCycleDescription:
                    "The recurring time period between billings for a subscription or service.",
                  billingCyclePlaceholder: "Select billing cycle...",
                  billingAnchorDateLabel: "Billing anchor date",
                  billingAnchorDateDescription:
                    "A billing anchor date is the specific day of the billing anchor date when recurring charges are processed. ",
                  billingAnchorDatePlaceholder: "Anchor date",
                  currencyLabel: "Currency",
                  currencyPlaceholder: "Select currency...",
                  unitRateLabel: "Unit rate",
                  unitRateDescription:
                    "The cost or price per individual usage unit.",
                  unitRatePlaceholder: "Type number",
                  costLabel: "The cost or price per individual usage unit.",
                  typeNumber: "Type number",
                  priceLabel: "Price",
                },
                licenseLabel: "License",
                licenseBasedLabel: "License based",
                notLicenseBasedLabel: "Not license based",
                licenseOption: {
                  sheetLimitLabel: "Sheet limit",
                  sheetLimitPlaceholder: "Type number",
                },
              },
              completeDialog: {
                message: "Successfully added Custom SaaS!",
                completeLinkButton: "Continue to import user account data",
                additionalButton: "Go to SaaS details",
              },
            },
          },
        },
        billingCycle: {
          month: "Month",
          year: "Year",
        },
      },
      overview: {
        pageTitle: "software/overview",
        cards: {
          inactiveUsersCard: {
            title: "Inactive Users",
            unit: "users",
          },
          integrationsCard: {
            title: "Integrations",
            unit: "software",
            label: "New software from last month",
          },
          monthlyBillingByAppCard: {
            title: "Monthly Billing By SaaS",
          },
          monthlyBillingByDeptCard: {
            title: "Monthly Billing By Dept",
            emptyDepartment: "(No department)",
          },
          peopleCard: {
            title: "People",
            unit: "persons",
            noDepartment: "(No department)",
          },
          potentialSavingsCard: {
            title: "Potential Savings",
            unit: "per month",
          },
          recentActivityCard: {
            title: "Recent Activity",
            activity:
              "<executor /> created the <software /> user account of <target />.",
            viewMore: "View more",
          },
          scheduledOperation: {
            title: "Scheduled Operation",
            todayAnnouncement: "Today: {{value}} persons are joining!",
            weekAnnouncement: "This week: {{value}} persons are joining!",
            viewMore: "View more",
          },
          upcomingRenewalsCard: {
            title: "Upcoming Renewals",
            unit: "in {{value}}",
          },
          usersCard: {
            title: "Users",
            unit: "users",
          },
        },
      },
      people: {
        pageTitle: "software/people",
        filterPeoplePlaceholder: "Filter by name...",
        tabs: {
          joined: "Joined",
          joining: "Joining",
          leaving: "Leaving",
          all: "All",
        },
        columns: {
          details: "Details",
          showProfile: "Show Profile",
          noApps: "No software",
          noDevices: "No devices",
        },
        cards: {
          goToProfile: "Go To Profile",
        },
        filters: {
          app: "Software",
          hasSomeApp: "Has Some Software",
          appCount: "Software Count",
          equalTo: "equals to",
          moreThan: "more than",
          lessThan: "less than",
          isMoreThan: "is more than",
          isLessThan: "is less than",
          model: "Model",
          selected: "{{value}} selected",
          locationOfOffice: "Location Of Office",
          filterLocationPlaceholder: "Filter location...",
          softwarePlaceholder: "Search for software",
          noResult: "No results.",
          workerTypePlaceholder: "Search for worker types",
          placePlaceholder: "Search for work place",
          quantityFilterOutput: "{{label}} <light>{{text}}</light> {{amount}}",
          filterOutput: "{{label}} <light>is</light> {{name}}",
          clearAll: "Clear all",
          clearFilter: "Clear filter",
          clearSearch: "Clear search",
          searchPlaceholder: "Search for people...",
          export: "Export",
          exportTooltip: "Export people data to CSV",
          exportSuccess: "Export started successfully",
          exportError: "Export failed",
        },
      },
      registry: {
        pageTitle: "Software / Registry",
        addSoftwareButton: "Add Integration Software",
        tabs: {
          all: "All",
          deactivated: "Deactivated",
          installed: "Installed",
          middlewareAndOs: "MW & OS",
          product: "Product",
          saas: "SaaS",
          scratch: "Scratch",
        },
        search: {
          placeholder: "Filter software...",
          customSaas: "Custom SaaS",
        },
        columns: {
          monthOverMonth: "MoM",
          pricingModel: {
            FIXED: "Fixed",
            FREE: "Free",
            HARDCODED: "Unique",
            LINEAR: "Linear",
            UNPREDICTABLE: "Unpredictable",
          },
          renewalDate: {
            renewalDateIsWithinOneMonth: "Renewal date is within one month",
          },
          saas: {
            noTenantName: "(No tenant name)",
            customSaasBadge: "Custom SaaS",
          },
        },
        addSoftwareLabel: "Add Software",
      },
      detail: {
        customSaasBadge: "Custom SaaS",
      },
      add: {
        header: {
          headerTitle: "Add software to your registry",
        },
        body: {
          selectSoftwareType: "Select the type:",
          itemCard: {
            requiredDetails: "Required details:",
            requiredItem: "Required item",
          },
          fillOutDetails: "Fill out the details",
        },
        softwareTypes: {
          customSaas: "Custom SaaS",
          installed: "Installed",
          mwOs: "MW • OS",
          scratch: "Scratch",
          product: "Product",
        },
        options: {
          description: "Or you might want to...",
          bulkCsvUpload: {
            title: "Bulk add by uploading a csv file",
            description:
              "Upload a CSV file to add multiple software items at once",
            selectedSoftwareType: "Selected software type:",
            button: "Upload CSV",
          },
          logo: {
            fileSizeError: "File size must be less than 500KB",
            fileReadError: "Failed to read file",
          },
        },
        step: {
          softwareIdInformation: "Software ID Information",
          basicInformation: "Basic",
          responsibilityInformation: "Responsibility",
          vendorInformation: "Vendor",
          detailedInformation: "Detail",
          installedSoftwareInformation: "Installed Software Information",
          architectureInformation: "Architecture",
        },
        progress: {
          total: "Total",
          required: "Required Items",
          filled: "Filled",
        },
        action: {
          addSoftware: "Add Software",
          next: "Next",
          optional: "Optional",
        },
        toast: {
          success: "Success",
          inputError: "Input Error",
          error: "Error",
          addSoftwareSuccess: "Software added successfully",
          inputErrorDescription: "Please check required fields",
          addSoftwareError: "Failed to add software",
        },
      },
      edit: {
        toast: {
          updateSuccess: "Update successful",
        },
      },
      options: {
        softwareType: {
          saas: "SaaS",
          customSaas: "Custom SaaS",
          installed: "Installed",
          mwOs: "MW & OS",
          scratch: "Scratch",
          product: "Product",
        },
        softwareCategory: {
          marketing: "Marketing",
          sales: "Sales",
          cs: "CS",
          research: "Research",
          hr: "HR",
          accountingFinance: "Accounting & Finance",
          legal: "Legal",
          operationWorkflow: "Operation & Workflow",
          sustainabilityIr: "Sustainability & IR",
          communication: "Communication",
          groupwareStorage: "Groupware & Storage",
          knowledgeDocument: "Knowledge & Document",
          productivity: "Productivity",
          devOps: "Dev & Ops",
          projectManagement: "Project Management",
          ai: "AI",
          rpaIpaas: "RPA & iPaaS",
          website: "Website",
          analytics: "Analytics",
          securityCompliance: "Security & Compliance",
          other: "Other",
        },
        deploymentMethod: {
          cloudBased: "Cloud Based",
          onPremise: "On-Premise",
          hybrid: "Hybrid",
        },
        gdprCompliance: {
          compliant: "Compliant",
          inProgress: "In Progress",
          nonCompliant: "Non Compliant",
        },
        accessControlType: {
          saml: "SAML",
          oauth: "OAuth",
          self: "Self",
          other: "Other",
        },
        usageStatus: {
          active: "Active",
          trial: "Trial",
          deactivated: "Deactivated",
          discontinued: "Discontinued",
        },
        patchStatus: {
          patched: "Patched",
          scheduled: "Scheduled",
          notPatched: "Not Patched",
        },
        instanceType: {
          saasTenant: "SaaS Tenant",
          onPremise: "On-Premise",
          dev: "Development",
          test: "Test",
          prod: "Production",
        },
        environment: {
          dev: "Development",
          stg: "Staging",
          prod: "Production",
        },
        installationMethod: {
          manual: "Manual",
          mdm: "MDM",
          installer: "Installer",
        },
        autoUpdateSetting: {
          enabled: "Enabled",
          disabled: "Disabled",
          manual: "Manual",
        },
        uninstallationMethod: {
          manual: "Manual",
          mdm: "MDM",
          installer: "Installer",
        },
      },
    },
    people: {
      title: "People",
      addPerson: "Add person",
      megaMenu: {
        employee: {
          header: "Employee",
          all: "All",
          active: "Active",
          newHire: "New Hire",
          leaving: "Leaving",
          onLeave: "On leave",
          joining: {
            header: "Joining",
            offered: "Offered",
            offerAccepted: "Offer accepted",
          },
        },
        contractor: {
          header: "Contractor",
          active: "Active",
          newBies: "NewBies",
          leaving: "Leaving",
          onLeave: "On leave",
          joining: {
            header: "Joining",
            offered: "Offered",
            offerAccepted: "Offer accepted",
          },
        },
      },
      overview: {
        pageTitle: "people/overview",
        cards: {
          personAvatarHoverCard: {
            link: "Go to Profile",
            workerType: {
              employee: "Employee",
              board_member: "Board member",
              contractor: "Contractor",
              collaborator: "Collaborator",
            },
          },
          workerTypeCard: {
            title: "Workforce",
            unit: "persons",
            type: {
              // TODO: common.workerType に統一したい
              employee: "Employee",
              board_member: "Board member",
              contractor: "Contractor",
              collaborator: "Collaborator",
            },
          },
          departmentCard: {
            title: "Employee & Contractor",
            unit: "persons",
          },
          leavingCard: {
            title: "Leaving",
            unit: "in {{month}}",
            tooltip:
              "“Leaving” refers to employees, board members, and contractors, excluding collaborators.",
          },
          renewalCard: {
            title: "Upcoming Renewal",
            unit: "in {{month}}",
          },
          headCountCard: {
            title: "Headcount Trend",
            labels: {
              employee: "Employee",
              contractor: "Contractor",
            },
          },
          onboardingCard: {
            title: "Onboarding",
            unit: "persons",
            upcoming: "Upcoming",
            tooltip:
              "“Onboarding” refers to employees, board members, and contractors, excluding collaborators, who have joined the company within one month.",
          },
          scheduleCard: {
            title: "Schedule",
            viewMore: "View more",
            terms: {
              today: "Today",
              thisWeek: "This Week",
              thisMonth: "This Month",
            },
            events: {
              joining: "Joining person",
              leaving: "Leaving person",
              transfer: "Transfer/Promotion",
            },
            personSuffix: "persons",
          },
          recentMovementCard: {
            title: "Recent Employee Movement",
            viewMore: "View more",
          },
        },
      },
      workforce: {
        pageTitle: "people/list",
        successfulMessage: "🎉 Successfully imported!",
        addPeople: "Add People",
        importFromGoogle: "Import from Google Workspace",
        importFromMicrosoft365: "Import from Microsoft365",
        filterPlaceholder: "Filter by name...",
        goToProfile: "Go To Profile",
        categories: {
          employee: {
            title: "Employee",
            joining: "Joining",
            offered: "Offered",
            offerAccepted: "Offer accepted",
            active: "Active",
            newHire: "New hire",
            leaving: "Leaving",
            onLeave: "On leave",
            comingBackSoon: "Coming back soon",
          },
          board: {
            title: "Board",
            joining: "Joining",
            offered: "Offered",
            offerAccepted: "Offer accepted",
            active: "Active",
            newbies: "Newbies",
            leaving: "Leaving",
          },
          contractor: {
            title: "Contractor",
            joining: "Joining",
            offered: "Offered",
            offerAccepted: "Offer accepted",
            active: "Active",
            newbies: "Newbies",
            leaving: "Leaving",
          },
          collaborator: {
            title: "Collaborator",
            active: "Active",
          },
          all: {
            title: "All",
            joining: "Joining",
            offered: "Offered",
            offerAccepted: "Offer accepted",
            active: "Active",
            newbies: "Newbies",
            leaving: "Leaving",
          },
        },
      },
      alumni: {
        filterBarButtons: {
          leavingDate: "Leaving date is within a month",
          is: "is",
          within_A_Month: "within a month",
        },
      },
      dialogs: {
        addPeople: {
          title: "Adding People",
          personCode: "Person Code",
          firstName: "First Name",
          middleName: "Middle Name",
          lastName: "Last Name",
          email: "Email",
          cancel: "Cancel",
          save: "Save",
          optional: "(Optional)",
          joinedOn: "Joining Date",
          job: "Job",
          notFound: "Not Found",
          selectJobButton: "Select job...",
          searchInputPlaceholder: "Search people group...",
        },
      },
      columns: {
        openMenu: "Open menu",
        details: "Details",
        showProfile: "Show Profile",
        noApps: "No software",
        noDevices: "No devices",
      },
      cards: {
        goToProfile: "Go To Profile",
      },
      settings: pagesPeopleSettingsEn,
    },
    publicIds: pagesPublicIdsEn,
    person: {
      title: "Person",
      header: {
        dept: "Dept",
        manager: "Manager",
        noWorkerType: "(No worker type)",
        noPosition: "(No position)",
        noJobType: "(No job type)",
        tenure: "{{joinedOn}} - {{leftOn}}",
      },
      leaveInfoBanner: {
        onLeaveStatus: "on leave",
        onScheduledLeaveStatus: "scheduled to leave",
        leaveStartDate: "Leave start date",
        leaveEndDate: "Leave end date",
        leaveType: "Leave type",
        changeLeaveDate: "Change leave date",
        changingLeaveDate: "Changing leave date",
        startReturnToWorkOperationPackage:
          "Start return to work operation package",
        startOnLeaveOperationPackage: "Start on leave operation package",
      },
      profile: {
        navigation: {
          title: {
            person: "Personal",
            employee: "Employee",
            board_member: "Board",
            contractor: "Contractor",
            collaborator: "Collaborator",
            contract: "Contract",
          },
          subheader: {
            basic: "Basic",
            identifiableInformation: "Identifiable Information",
            contact: "Contact",
            address: "Address",
            family: "Family Information",
            familySocialInsuranceAndTaxation:
              "Family Social Insurance and Taxation",
            snsAndItInformation: "SNS & IT Information",
            religion: "Religion",
            jobAndGrade: "Job and Grade",
            department: "Department",
            place: "Place",
            contractData: "Contract data",
          },
        },
        personalInformation: {
          itemCard: {
            familyRelationship: "Family relationship",
            familyCohabitationType: "Family cohabitation type",
            basicPensionNumber: "Basic Pension Number",
            documentsConfirmingBasicPensionNumberFiles:
              "Documents confirming Basic Pension Number",
            occupationClassificationOfDependents:
              "Occupation classification of dependents",
            socialInsuranceSupport: "Social insurance support classification",
            annualIncomeForSocialInsurance:
              "Annual income for social insurance",
            monthlyIncomeForSocialInsurance:
              "Monthly income for social insurance",
            socialInsuranceBecameDependentDate:
              "Date became dependent for social insurance",
            reasonBecameDependentForSocialInsurance:
              "Reason became dependent for social insurance",
            socialInsuranceNoLongerDependentDate:
              "Date no longer dependent for social insurance",
            reasonNoLongerDependentForSocialInsurance:
              "Reason no longer dependent for social insurance",
            employmentInsuranceReceiptClassification:
              "Employment insurance receipt classification",
            employmentInsuranceStartDate: "Employment insurance start date",
            employmentInsuranceEndDate: "Employment insurance end date",
            basicDailyAllowanceForEmploymentInsurance:
              "Basic daily allowance for employment insurance",
            taxSupport: "Tax support classification",
            dependentStatusUnderTheTaxLaw: "Dependent status under the tax law",
            estimatedAnnualIncomeUnderTheTaxLaw:
              "Estimated annual income under the tax law",
            dateBecameDependentUnderTheTaxLaw:
              "Date became dependent under the tax law",
            reasonBecameDependentForTax: "Reason became dependent for tax",
            dateNoLongerDependentUnderTheTaxLaw:
              "Date no longer dependent under the tax law",
            reasonNoLongerDependentForTax: "Reason no longer dependent for tax",
            emittanceAmountWhenResidingAbroad:
              "Remittance amount when residing abroad",
            internationalStudent: "International student",
            documentProvingStudyAbroadFiles: "Documents proving study abroad",
            documentRelatedToRemittanceFiles: "Documents related to remittance",
            familyRelationshipDocuments: "Family relationship documents",
            familyDisability: "Disability exemption target",
          },
        },
        publicId: {
          navigation: {
            title: "Public ID",
            subheader: {
              passport: "Passport",
              residenceStatus: "Residence Status",
              workVisa: "Work Visa",
            },
          },
          itemCard: {
            passportNumber: "Passport number",
            passportName: "Passport name",
            residenceStatusType: "Residence status type",
            residenceStatusCode: "Residence status code",
            visaType: "Visa type",
            residenceCardNumber: "Residence card number",
            description: "Residence status detailed description",
            permissionExtraActivities: "Permission for extra activities",
            dispatchContractType: "Dispatch contract type",
            validityPeriodTo: "Validity period to",
            issueDate: "Residence status issue date",
            entryDate: "Entry date",
            validityPeriodFrom: "Validity period from",
            issuingCountryCode: "Issuing country code",
            nationalityAndRegion: "Nationality & Region",
            residenceCardFiles: "Residence card image",
            yes: "Yes",
            no: "No",
          },
        },
        employeeInformation: {
          navigation: {
            title: "Employee Information",
            subheader: {
              employeeIdAndContract: "Employee ID & Employment Contract",
              employeeContact: "Employee Contact",
              assignmentInfo: "Employee Assignment Information",
              workProfile: "Work Information",
              compensation: "Salary & Compensation Information",
              socialInsuranceJapan: "Social Insurance (Japan)",
              taxJapan: {
                residentTax: "Resident Tax",
                incomeTax: "Income Tax",
              },
              commutingInformation: "Commuting Transportation Information",
              employeePaymentMethod: "Employee Payment Method",
            },
          },
          addEmployeeSubIdName: "Add Employee Sub ID",
          addContact: "Add Contact",
          addJobType: "Add Job Type",
          addJobFunction: "Add Job Function",
          addPlace: "Add Assigned Location",
          itemCard: {
            workerNumber: "Employee Number",
            department: "Department",
            jobTitle: "Job Title",
            jobType: "Job Type",
            jobGrade: "Job Grade",
            jobFunction: "Job Function",
            jobCompetency: "Job Competency",
            jobLevel: "Job Level",
            grade: "Grade",
            workLocation: "Work Location",
            workLocationName: "Actual work site location",
            workLocationDetails: "Work location details",
            fieldWorkEligibility: "Field Work Eligibility",
            businessTripEligibility: "Business Trip Eligibility",
            relocationEligibility: "Relocation Eligibility",
            remoteWorkEligibility: "Remote Work Eligibility",
            workScheduleType: "Work Schedule Type",
            workMode: "Work Mode",
            weeklyWorkHours: "Weekly scheduled work hours",
            dailyWorkHours: "Daily scheduled work hours",
            overtimeLimit: "Overtime limit",
            nightShiftStatus: "Night shift",
            primaryModeOfTransportation: "Primary Mode of Transportation",
            // Commute route related
            routeDetail: "Route Detail",
            commuteDistance: "Commute Distance",
            averageTravelTime: "Average Travel Time",
            // Transportation fare related
            transportationFareSection: "Transportation Fare",
            fareCurrency: "Currency",
            fareType: "Fare Type",
            fareAmount: "Fare Amount",
            // Commuting allowance related
            commutingAllowanceEligibility: "Commuting Allowance Eligibility",
            allowanceAmount: "Allowance Amount",
            allowanceTiming: "Payment Timing",
            allowanceCurrency: "Currency",
            icCardUsage: "IC Card Usage",
            placeHealthInsuranceName: "Health insurance name",
            placePensionInsuranceName: "Pension insurance name",
            placeEmploymentInsuranceName: "Employment insurance name",
            placeWorkersCompensationInsuranceName:
              "Workers' compensation insurance name",
            contractDetail: "Employment Agreement",
            healthInsuranceReferenceNumber: "Health insurance reference number",
            healthInsuranceEnrollmentDate: "Health insurance enrollment date",
            annualIncomeForHealthInsuranceUnitYen: "Annual income (unit: yen)",
            healthInsuranceMonthlyCompensation:
              "Health insurance monthly compensation (unit: yen) (cash)",
            healthInsuranceMonthlyCompensationInKind:
              "Health insurance monthly compensation (unit: yen) (in kind)",
            pensionEnrollmentDate: "Pension enrollment date",
            pensionMonthlyCompensation: "Pension standard monthly remuneration",
            employmentInsuredPersonNumber:
              "Employment insurance insured person's number",
            employmentInsuredPersonNumberImage:
              "Employment insurance insured person's number image",
            employmentInsuredPersonNumberUnknownReason:
              "Reason insured person's number is unknown",
            employmentEnrollmentDate: "Employment insurance enrollment date",
            pastCompanyName: "Past company name",
            pastEmploymentPeriod: "Past employment period",
            workersCompensationEnrollmentDate:
              "Workers' compensation enrollment date",
            employeePensionInsuranceNumber: "Employee Pension Insurance Number",
            basicPensionNumber: "Basic Pension Number",
            basicPensionNumberImage: "Basic Pension Number Image",
            basicPensionNumberUnknownReason:
              "Reason basic pension number is unknown",
            residentStatus: "Resident Status",
            withholdingTaxClassification: "Withholding Tax Classification",
            municipalTaxCode: "Municipal Tax Code",
            specialCollectionStartDate: "Special collection start date",
            previousJobTaxStatus: "Previous job tax status",
            recipientNumber: "Recipient number",
            // Payment Method
            paymentMethodStatus: "Payment method status",
            bankName: "Bank name",
            branchName: "Branch name",
            bankCode: "Bank code",
            branchCode: "Branch code",
            accountType: "Account type",
            accountNumber: "Account number",
            accountHolderName: "Account holder name",
            openingDate: "Opening date",
            validityDate: "Validity date",
            contactDetailsAtBank: "Contact details at bank",
            // Income Tax
            disabled: "Disabled person",
            workingStudent: "Working student",
            headOfHouseholdsName: "Head of household's name",
            headOfHouseholdsRelationship: "Head of household's relationship",
            widow: "Widow(er)",
            singleParent: "Single parent",
            disabilityClassification: "Disability classification",
            typeOfDisabilityCertificate: "Type of disability certificate",
            disabilityGrade: "Disability grade",
            dateOfDisabilityCertificateIssuance: "Certificate issuance date",
            disabilityCertificateFile: "Disability certificate file",
            workingStudentSchoolName: "School name",
            workingStudentDateOfEnrollment: "Date of enrollment",
            workingStudentEstimatedIncome: "Estimated income",
            workingStudentTypeOfIncome: "Type of income",
            workingStudentStudentIdCardFile: "Student ID card file",
            widowReason: "Widow reason",
            widowDetail: "Widow detail",
            singleParentReason: "Single parent reason",
            singleParentDetail: "Single parent detail",
            employeeId: "Employee ID",
            employeeSubId: "Employee Sub ID",
            employeeSubIdName: "Employee Sub ID Name",
          },
        },
        itemCard: {
          addAnother: "Add another",
          addEndDateManually: "Add end date manually",
          selectBloodType: "Select Blood type",
          selectBloodRhFactor: "Select Rh blood factor",
          contractDateFrom: "Start date",
          contractDateTo: "End date",
          selectGrade: "Select grade",
          selectJobType: "Select job type",
          selectJobTitle: "Select job title",
          selectJobCompetency: "Select job competency",
          selectJobGrade: "Select job grade",
          selectJobFunction: "Select job function",
          selectJobLevel: "Select job level",
          selectWorkMode: "Select work mode",
          selectSex: "Select Sex",
          selectGender: "Select Gender",
          selectPlace: "Select Place",
          selectAssignedLocation: "Select Assigned Location",
          selectStartDate: "Select start date",
          selectEndDate: "Select end date",
          selectNationality: "Select nationality",
          selectMaritalStatus: "Select marital status",
          selectPhoneType: "Select phone type",
          selectEmployeeSubIdName: "Select employee sub id name",
          nationality: "Nationality",
          maritalStatus: "Marital status",
          bloodType: "Blood type",
          bloodRhFactor: "Rh blood factor",
          certificateOfResidence: "Certificate of Residence",
          city: "City",
          cityPlaceholder: "Cityville",
          country: "Country",
          empty: "-",
          postalCode: "ZIP / Postal code",
          postalCodePlaceholder: "100-0001",
          stateProvince: "State/Province Code",
          streetAddressInput: "Street Address",
          streetAddressInputPlaceholder: "123 Main Street\nApartment 101",
          addStreetAddressLine2: "Add optional address line 2",
          streetAddressLine2Input: "Address line 2",
          streetAddressLine2InputPlaceholder:
            "Apartment, suite, etc. (optional)",
          countryAddress: "Country address",
          moveInDate: "Move in date/Start date",
          moveOutDate: "End date",
          currentAddress: "Current Address",
          residenceType: "Residence type",
          dateOfBirth: { title: "Date of birth", age: "{{value}} years old" },
          email: "Email",
          workerNumber: "Employee Number",
          familyRegister: "Family Register",
          grade: "Grade",
          jobCompetency: "Job Competency",
          jobFunctions: "Job Functions",
          jobGrade: "Job Grade",
          jobTitle: "Job title",
          jobTypes: "Job Types",
          jobLevel: "Job Level",
          workMode: "Work Mode",
          employmentType: "Employment Type",
          contractorType: "Contractor Type",
          collaboratorType: "Collaborator Type",
          boardMemberType: "Board Member Type",
          name: "Name",
          familyName: "Last or family name",
          givenName: "First or given name",
          middleName: "Middle name(s)",
          familyNamePronunciation: "Last or family name",
          givenNamePronunciation: "First or given name",
          optionalPronunciation: "Pronunciation (optional)",
          phone: "Phone",
          preferredName: "Preferred Name",
          sex: "Sex",
          gender: "Gender",
          startDate: "Start date",
          state: "State / Province",
          streetAddress: "Street address",
          undecidedEndDate: "End date undecided",
          unlimitedTerm: "Unlimited term",
          consecutiveTerm: "Consecutive term",
          term: "Term",
          places: "Places",
          assignedLocations: "Assigned Location",
          zip: "ZIP / Postal Code",
          hometown: "Hometown",
          birthPlace: "Birth Place",
          religion: "Religion",
          religionDetail: "Religion detail",
          primaryPhone: "Primary Phone",
          secondaryPhone: "Secondary Phone",
          primaryEmail: "Email (Primary)",
          secondaryEmail: "Email (Secondary)",
          phoneType: "Phone type",
          emergencyContact: "Emergency Contact",
          relationship: "Relationship",
          unregistered: "Unregistered",
        },
        ContractSections: {
          ContractDataSection: {
            selectWorkerType: "Select worker type",
            searchWorkerTypeName: "Search worker type by name",
          },
        },
        PersonalSections: {
          PersonalContactSection: {
            title: "Contact",
            addEmailLabel: "Add email",
            AddEmail: {
              title: "Adding contact",
              addAnotherEmail: "Add another email contact",
            },
            deleteEmail: {
              description:
                "Are you sure you want to remove {{email}} from the {{personName}}?",
            },
            deletePhone: {
              description:
                "Are you sure you want to remove {{phone}} from the {{personName}}?",
            },
          },
          PersonalFamilySection: {
            title: "Family Information",
            viewProfile: "View profile",
            viewDialog: {
              title: "Profile: {{name}}",
              groups: {
                personal: {
                  title: "Personal Information",
                  columns: {
                    relationship: "Relationship",
                    familyName: "Last Name",
                    givenName: "First Name",
                    familyNameEn: "Last Name (English)",
                    givenNameEn: "First Name (English)",
                    familyNameKana: "Last Name (Kana)",
                    givenNameKana: "First Name (Kana)",
                    middleName: "Middle Name",
                    maidenName: "Maiden Name",
                    maidenNameKana: "Maiden Name (Kana)",
                    maidenNameEn: "Maiden Name (English)",
                    nickname: "Nickname",
                    bloodType: "Blood Type",
                    rhType: "RH Type",
                    sex: "Sex",
                    gender: "Gender Identity",
                    nationality: "Nationality",
                  },
                },
                address: {
                  title: "Address",
                  columns: {
                    country: "Country",
                    postalCode: "Postal Code",
                    stateProvince: "State/Province",
                    city: "City",
                    streetAddress: "Street Address",
                    streetAddressLine2: "Building Name/Room Number",
                    residenceType: "Residence Type",
                  },
                },
              },
            },
          },
        },
        WorkerSections: {
          ContactSection: {
            subheader: "Contact",
            addContact: "Add Contact",
            AddContact: {
              title: "Adding contact",
              addAnotherEmail: "Add Another Email",
            },
          },
          DepartmentSection: {
            title: "Department",
            addDepartmentLabel: "Add department and position",
            departments: "Departments",
            positions: "Positions",
            selectPosition: "Select position",
            searchPositionName: "Search position by name",
            selectDepartment: "Select department",
            searchDepartmentName: "Search department by name",
            addDepartment: {
              title: "Adding department and/or position",
              description:
                "If the position is not department-specific, leave the department field blank.",
            },
            deleteDepartment: {
              description:
                "Removing the {{departmentName}} will also remove the {{positionName}} associated with the {{personName}}'s departmental information. Are you sure to want to proceed with this action?",
              descriptionWithoutPosition:
                "Are you sure you want to remove {{departmentName}} from the {{personName}}?",
            },
          },
          JobAndGradeSection: {
            JobFunction: {
              title: "JobFunction",
              jobFunction: "jobFunction",
              addJobFunctionLabel: "Add jobFunction",
              selectJobFunction: "Select jobFunction",
              searchJobFunctionName: "Search job function by name",
              addJobFunction: {
                title: "Add jobFunction",
              },
              deleteJobFunction: {
                description:
                  "Are you sure you want to remove {{jobFunctionName}} from the {{personName}}?",
              },
            },
            JobType: {
              title: "JobType",
              jobType: "JobType",
              addJobTypeLabel: "Add jobType",
              selectJobType: "Select jobType",
              searchJobTypeName: "Search jobType by name",
              addJobType: {
                title: "Add jobType",
              },
              deleteJobType: {
                description:
                  "Are you sure you want to remove {{jobTypeName}} from the {{personName}}?",
              },
            },
            Grade: {
              searchGradeName: "Search grade by name",
            },
            JobLevel: {
              searchJobLevelName: "Search job level by name",
            },
            WorkMode: {
              searchWorkModeName: "Search work mode by name",
            },
            JobTitle: {
              searchJobTitleName: "Search job title by name",
            },
            JobCompetency: {
              searchJobCompetencyName: "Search job competency by name",
            },
            JobGrade: {
              searchJobGradeName: "Search job grade by name",
            },
            WorkerMode: {
              searchWorkerModeName: "Search work mode by name",
            },
          },
          PlaceSection: {
            title: "Assigned Location",
            addDepartmentLabel: "Add assigned location",
            places: "Assigned Location",
            selectPlace: "Select assigned location",
            searchPlaceName: "Search assigned location by name",
            addPlace: {
              title: "Add assigned location",
            },
            deletePlace: {
              description:
                "Are you sure you want to remove {{placeName}} from the {{personName}}?",
            },
          },
        },
        department: {
          deleteDialog: {
            title: "Removing department",
            description:
              "Are you sure you want to remove {{name}} from {{personName}}?",
            button: "Remove",
          },
          trashTooltip: "Primary department cannot be removed",
          primaryTooltip:
            "If you want to change the primary department, set another department as primary.",
        },
        jobType: {
          deleteDialog: {
            title: "Removing job type",
            description:
              "Are you sure you want to remove {{name}} from {{personName}}?",
            button: "Remove",
          },
          trashTooltip: "Primary job type cannot be removed",
          primaryTooltip:
            "If you want to change the primary job type, set another job type as primary.",
        },
        jobFunction: {
          deleteDialog: {
            title: "Removing job function",
            description:
              "Are you sure you want to remove {{name}} from {{personName}}?",
            button: "Remove",
          },
        },
        place: {
          deleteDialog: {
            title: "Removing assigned location",
            description:
              "Are you sure you want to remove {{name}} from {{personName}}?",
            button: "Remove",
          },
          trashTooltip: "Primary assigned location cannot be removed",
          primaryTooltip:
            "If you want to change the primary assigned location, set another assigned location as primary.",
        },
        avatar: {
          editPhoto: "Edit photo",
          successfulMessage: "Photo has been changed!",
        },
        educationsAndQualifications: {
          title: "Educations and Qualifications",
          certification: {
            add: "Add Certification",
            filterPlaceholder: "Search by certification ID, name, party...",
            dialog: {
              edit: {
                title: "Editing {{resource}}",
                certificationId: "Certification ID",
                certificationName: "Certification Name",
                certificationParty: "Certification Party",
                effectiveDate: "Effective Date",
                expirationDate: "Expiration Date (Optional)",
                renewalDate: "Renewal Date (Optional)",
              },
              delete: {
                title: "Delete {{resource}}?",
                description:
                  "{{resource}} and all of its data will be deleted. Do you still want to go ahead and delete?",
              },
            },
          },
          tabs: {
            certification: "Certification",
          },
        },
      },
      add: {
        intro: {
          header: {
            headerTitle: "Add person data to your workforce",
            description:
              "Person data is essential to all features of HR Force and its integration with other Force products. Please ensure that all relevant fields are completed as thoroughly as possible. In DRESS CODE, persons are categorized into the following four types.",
          },
          body: {
            selectMemberType: "Select the Type:",
            fillOutDetails: "Fill out details",
            itemCard: {
              title: {
                // TODO: common.workerType に統一したい
                employee: "Employee",
                board_member: "Board Member",
                contractor: "Contractor",
                collaborator: "Collaborator",
              },
              requiredDetails: "Required details:",
              givenName: "Given name",
              email: "Email contact",
              employmentType: "Employment type",
              contractorType: "Contractor type",
              boardMemberType: "Board Member type",
              collaboratorType: "Collaborator type",
              contractTerm: "Contract term",
              join: {
                employee: "Joining date",
              },
            },
          },
          options: {
            description: "Or you might want to...",
            syncHR: "Sync with external HR services",
            bulkCsvUpload: {
              title: "Bulk add by uploading a csv file",
              description:
                "Use this procedure when you like to add multiple person data at once. You will need to prepare a csv file following the DRESS CODE format.",
              selectedMemberType: "Type:",
              selectedMemberTypeTitle: {
                // TODO: common.workerType に統一したい
                employee: "Employee",
                board_member: "Board Member",
                contractor: "Contractor",
                collaborator: "Collaborator",
              },
              button: "Prepare csv file",
            },
            previouslyWorked:
              "Select someone who have previously worked for {{value}} ",
            recruitmentCandidates:
              "Select someone from the recruitment process",
          },
        },
        form: {
          navigation: {
            title: {
              employee: "Add Employee",
              board_member: "Add Board Member",
              contractor: "Add Contractor",
              collaborator: "Add Collaborator",
            },
            subTitle: {
              personal: "Personal data",
              worker: {
                // TODO: common.workerType に統一したい
                employee: "Employee",
                board_member: "Board Member",
                contractor: "Contractor",
                collaborator: "Collaborator",
              },
              contract: "Contract data",
            },
            step: {
              one: "Personal data",
              two: "Personal contact",
              three: "Address",
              four: {
                employee: "Employee data",
                board_member: "Board Member data",
                contractor: "Contractor data",
                collaborator: "Collaborator data",
              },
              five: "Contact",
              six: "Job/Grade",
              seven: "Department",
              eight: "Assigned Location",
              nine: "Contract data",
              ten: "Payroll",
              add: {
                employee: "Add Employee to workforce",
                board_member: "Add Board Member to workforce",
                contractor: "Add Contractor to workforce",
                collaborator: "Add Collaborator to workforce",
              },
              completed: {
                employee: "Added the employee data,",
                board_member: "Added the Board Member data",
                contractor: "Added the Contractor data",
                collaborator: "Added the Collaborator data",
                completedBy: "Completed by",
                goToProfile: "Go to profile",
                continueAdding: "Continue adding another person",
              },
            },
            item: {
              useCurrentAddress: "Use current address",
              useDifferentAddress: "Use a different address",
              useCertificateOfResidence:
                "Use certificate of residence Description",
              notApplicable: "Family register is not applicable",
              workerNumber: "Employee Number",
              id: "ID",
              useRealName: "Use real name, {fullName}",
              usePreferredName: "Use a preferred name",
              permanentTerm: "Permanent employment",
              fixedTerm: "Fixed-term employment",
              contractType: "Contract type",
              term: {
                employee: "Term",
                board_member: "Term",
                contractor: "Term",
                collaborator: "Term",
              },
              selectWorkerTypePlaceholder: {
                employee: "Add Employee to workforce",
                board_member: "Add Board Member to workforce",
                contractor: "Add Contractor to workforce",
                collaborator: "Add Collaborator to workforce",
              },
            },
          },
          progressbar: {
            total: "Total",
            mustItem: "Must Item",
            left: "{{value}}left",
            filled: "filled",
            modeSetting: "Mode Settings",
            mustItemOnly: "Must item only",
          },
        },
      },
      apps: {
        deactivateButton: "Deactivate",
        createButton: "Create",
      },
      devices: {
        assignButton: "Assign device",
        unassignButton: "Unassign",
      },
      importCsv: pagesPersonImportCsvEn,
      externalHrSaas: pagesPersonExternalHrSaasEn,
    },
    devices: {
      title: "Devices",
      addDevice: "Add Device",
      columns: {
        openMenu: "Open Menu",
        showDevice: "Show Device",
        assignDevice: "Assign Device",
        putInMaintenance: "Put in maintenance",
        recoverFromMaintenance: "Recover from maintenance",
        decommission: "Decommission",
      },
      header: {
        purchasedFrom: "Purchased From",
        computer: "Computer",
        unassigned: "Unassigned",
        assigned: "Assigned",
        placed: "Placed",
        available: "Available",
        underMaintenance: "Under Maintenance",
        inDistribution: "In Distribution",
        decommissioned: "Decommissioned",
      },
      profile: {
        sections: {
          base: {
            id: "Device ID",
            type: "Type",
            name: "Name",
            manufacturer: "Manufacturer",
            model: "Model",
            serialNumber: "Serial Number",
            imei: "IMEI",
            imei2: "IMEI2",
            memo: "Memo",
            deviceTag: "Inventory ID",
            assetTag: "Asset Tag",
            modelNumber: "Model Number",
            managementLabel: "Management Label",
            generateLabel: "Generate Label",
            regenerateLabel: "Regenerate Label",
            tagsTooltipDialog: {
              itemName: "Item Name",
              description: "Description",
              assetTagDescription:
                "Any value you need to set for managing your assets.",
              deviceTagDescription:
                "It is used when a device-specific management ID is required in addition to the asset tag.",
            },
          },
          computer: {
            type: "Computer Type",
            osPlatform: "Platform",
            osName: "OS Name",
            osVersion: "OS Version",
            osBuild: "OS Build",
            cpuManufacturer: "CPU Manufacturer",
            cpuModel: "CPU Model",
            cpuArchitecture: "CPU Architecture",
            cpuProcessorCount: "Processor Count",
            cpuCoreCount: "Core Count",
            cpuClockMhz: "CPU Clock (MHz)",
            totalStorageMB: "Total Storage (MB)",
          },
          monitor: {
            sizeInInch: "Size (Inch)",
            resolutionWidth: "Resolution Width",
            resolutionHeight: "Resolution Height",
            numberOfColors: "Number of Colors",
            refreshRateHz: "Refresh Rate (Hz)",
            displayType: "Display Type",
            manufactureDate: "Manufacture Date",
            panelType: "Panel Type",
            aspectRatio: "Aspect Ratio",
            brightness: "Brightness",
            contrastRatio: "Contrast Ratio",
            colorGamut: "Color Gamut",
            inputPorts: "Input Ports",
            activePortUsed: "Active Port Used",
            touchCapability: "Touch Capability",
            displayArrangement: "Display Arrangement",
            rotationPivotMode: "Rotation/Pivot Mode",
          },
          storage: {
            type: "Storage Type",
            name: "Product Name / Model",
            capacityMB: "Capacity (MB)",
            storageInterfaceType: "Interface Type",
            storageFormFactor: "Form Factor",
            storageSlotNumber: "Slot Number",
            storageManufacturer: "Manufacturer",
            storageSerialNumber: "Serial Number",
            storageFirmwareVersion: "Firmware Version",
            storageCacheSizeBytes: "Cache Size (Bytes)",
            storageNandType: "NAND Type",
            storageTrimSupport: "TRIM Support",
          },
          port: {
            type: "Port Type",
            specification: "Specification",
            numOfPorts: "Number of Ports",
          },
          ram: {
            totalSizeBytes: "Total Size (Bytes)",
            ramSizeBytes: "RAM Size (Bytes)",
            ramGeneration: "Memory Type",
            ramFormFactor: "RAM Form Factor",
            ramSpeedHz: "RAM Speed (Hz)",
            ramEccSupported: "ECC Supported",
            ramRegistered: "Registered / Unbuffered",
            ramManufacturer: "Manufacturer",
            ramSerialNumber: "Serial Number",
            ramManufactureDate: "Manufacture Date",
            ramPartNumber: "Part Number",
            ramJedecCompliant: "JEDEC Compliant",
          },
          battery: {
            batteryPresence: "Battery Presence",
            batteryType: "Battery Type",
            manufacturer: "Manufacturer",
            batteryModelName: "Battery Model Name",
            batterySerialNumber: "Battery Serial Number",
            manufactureDate: "Manufacture Date",
            designCapacity: "Design Capacity",
            fullChargeCapacity: "Full Charge Capacity",
            currentCharge: "Current Charge",
            batteryLevelPercent: "Battery Level (%)",
            wearLevelPercent: "Wear Level (%)",
            voltage: "Voltage",
            current: "Current",
            capacityUnit: "Capacity Unit",
          },
          networkInterface: {
            hostname: "Hostname",
            domainName: "Domain Name",
            fqdn: "Fully Qualified Domain Name (FQDN)",
            connectionType: "Connection Type",
            networkInterfaceName: "Network Interface Name",
            macAddress: "MAC Address",
            interfaceType: "Interface Type",
            driverName: "Driver Name",
            nicVendor: "NIC Vendor",
            ipv4Address: "IPv4 Address",
            ipv6Address: "IPv6 Address",
            subnetMask: "Subnet Mask",
            defaultGateway: "Default Gateway",
            dnsServer: "DNS Server",
            dhcpEnabled: "DHCP Enabled",
            staticIpConfigured: "Static IP Configured",
            ipAssignmentSource: "IP Assignment Source",
          },
          network: {
            type: "Network Type",
            hostname: "Hostname",
            domainName: "Domain Name",
            fullyQualifiedDomainName: "Fully Qualified Domain Name (FQDN)",
            connectionType: "Connection Type",
            networkInterfaceName: "Network Interface Name",
            macAddress: "MAC Address",
            interfaceType: "Interface Type",
            driverName: "Driver Name",
            nicVendor: "NIC Vendor",
            ipv4Address: "IPv4 Address",
            ipv6Address: "IPv6 Address",
            subnetMask: "Subnet Mask",
            defaultGateway: "Default Gateway",
            dnsServer: "DNS Server",
            dhcpEnabled: "DHCP Enabled",
            staticIpConfigured: "Static IP Configured",
            ipAssignmentSource: "IP Assignment Source",
            numberOfConnectedDisplays: "Number of Connected Displays",
          },
          networkAndSim: {
            mobileCarrier: "Mobile Carrier",
            simStatus: "SIM Status",
            iccid: "ICCID Number",
            phoneNumber: "Phone Number",
            networkStatus: "Network Status",
            connectedWifiSsid: "Connected Wi-Fi SSID",
            ipAddress: "IP Address",
          },
          networkConfiguration: {
            connectedSsidVpn: "Connected SSID / VPN",
            proxyConfiguration: "Proxy Configuration",
            hostname: "Hostname",
            dnsSettings: "DNS Settings",
            connectionHistory: "Connection History",
          },
          securityConfiguration: {
            mdmManagementStatus: "MDM Management Status",
            passcodeEnabled: "Passcode Enabled",
            passcodePolicyCompliant: "Passcode Policy Compliant",
            jailbreakRootDetection: "Jailbreak / Root Detection",
            deviceEncryption: "Device Encryption",
            securityPatchLevel: "Security Patch Level",
            factoryResetProtection: "Factory Reset Protection",
            remoteWipeEnabled: "Remote Wipe Enabled",
            lostModeStatus: "Lost Mode Status",
            deviceCertificate: "Device Certificate",
          },
          securityStatus: {
            antivirusStatus: "Antivirus Status",
            firewallSettings: "Firewall Settings",
            diskEncryption: "Disk Encryption (BitLocker / FileVault)",
            passwordPolicyCompliance: "Password Policy Compliance",
            adminPrivileges: "Admin Privileges",
            userLoginHistory: "User Login History",
            tamperProtectionStatus: "Tamper Protection Status",
          },
          remoteManagementFeatures: {
            remoteLockStatus: "Remote Lock Status",
            remoteWipeAvailability: "Remote Wipe Availability",
            lockScreenMessage: "Lock Screen Message",
            remoteCommandHistory: "Remote Command History",
          },
          remoteManagementHistory: {
            lastRemoteCommand: "Last Remote Command",
            executionTime: "Execution Time",
            issuedBy: "Issued By",
          },
          gpu: {
            totalGpuMemoryBytes: "Total GPU Memory (Bytes)",
            gpuName: "GPU Name",
            gpuVendor: "GPU Vendor",
            gpuModelNumber: "GPU Model Number",
            gpuGeneration: "GPU Generation",
            gpuArchitecture: "GPU Architecture",
            dedicatedGpuMemoryBytes: "Dedicated GPU Memory (Bytes)",
            sharedGpuMemoryBytes: "Shared GPU Memory (Bytes)",
            totalAvailableGpuMemoryMB: "Total Available GPU Memory (MB)",
            driverVersion: "Driver Version",
            driverProvider: "Driver Provider",
            clockSpeedBaseHz: "Clock Speed (Base Hz)",
            clockSpeedBoostHz: "Clock Speed (Boost Hz)",
            cudaCores: "CUDA Cores",
            shaderUnits: "Shader Units",
            maxDisplaySupport: "Max Display Support",
            supportedApis: "Supported APIs",
            gpuUsagePercent: "GPU Usage (%)",
            gpuTemperatureC: "GPU Temperature (°C)",
            hardwareAcceleration: "Hardware Acceleration",
          },
          firmware: {
            biosVendor: "BIOS Vendor",
            biosVersion: "BIOS Version",
            biosReleaseDate: "BIOS Release Date",
            firmwareType: "Firmware Type",
            firmwareMode: "Firmware Mode",
            biosUpdateEnabled: "BIOS Update Enabled",
            secureBootEnabled: "Secure Boot Enabled",
            biosPasswordSet: "BIOS Password Set",
            tpmEnabled: "TPM Enabled",
            tpmVersion: "TPM Version",
            intelTxtEnabled: "Intel Trusted Execution Technology",
            biosLock: "BIOS Lock / Write Protection",
            hardwareEncryptionSupport: "Hardware Encryption Support",
            systemUuid: "System UUID",
            smbiosVersion: "SMBIOS Version",
            biosRomSizeBytes: "BIOS ROM Size",
            bootSequenceOrder: "Boot Sequence / Order",
            wakeOnLanEnabled: "Wake-on-LAN Status",
            pxeBootEnabled: "PXE Boot Enabled",
            motherboardModel: "Motherboard Model",
            systemSerialNumber: "System Serial Number",
            systemManufacturer: "System Manufacturer",
            systemModel: "System Model",
            oemBiosCustomization: "OEM BIOS Customization",
          },
          processor: {
            cpuName: "CPU Name",
            cpuVendor: "CPU Vendor",
            cpuSeries: "CPU Series",
            cpuGeneration: "CPU Generation",
            cpuCoreCount: "CPU Core Count",
            cpuThreadCount: "CPU Number of Threads",
            cpuClockSpeedHz: "CPU Clock Speed (Hz)",
            cpuMaxTurboFrequencyHz: "Max Turbo Frequency (Hz)",
            cpuCacheSizeL1Bytes: "Cache Size L1 (Bytes)",
            cpuCacheSizeL2Bytes: "Cache Size L2 (Bytes)",
            cpuCacheSizeL3Bytes: "Cache Size L3 (Bytes)",
            cpuTdpWatt: "Thermal Design Power (TDP)",
            cpuSocketType: "Socket Type",
            cpuProcessNode: "Process Node",
          },
          os: {
            operatingSystemType: "Operating System Type",
            osVersion: "OS Version",
            osName: "OS Name",
            osEdition: "OS Edition",
            buildNumber: "Build Number",
            servicePackPatchLevel: "Service Pack / Patch Level",
            securityPatchDate: "Security Patch Date",
            automaticUpdatesEnabled: "Automatic Updates Enabled",
            kernelVersion: "Kernel Version",
            architecture: "Architecture",
            bitness: "Bitness",
            withVirtualOs: "With Virtual OS",
            osSupportLifecycle: "OS Support Lifecycle",
            firewallStatus: "Firewall Status",
            antivirusSoftwareCompatibility: "AV Software Compatibility",
            osInstallDate: "OS Install Date",
            bootMode: "Boot Mode",
            diskEncryptionEnabled: "Disk Encryption Enabled",
          },
          logsAudit: {
            complianceStatus: "Compliance Status",
            alertViolationHistory: "Alert Violation History",
            auditLogs: "Audit Logs",
            inventoryStatus: "Inventory Status",
          },
          provisioningDeployment: {
            setupCompletedDate: "Setup Completed Date",
            osInstallationType: "OS Installation Type",
            securityProfileApplied: "Security Profile Applied",
            mdmEnrollmentStatus: "MDM Enrollment Status",
            deploymentDate: "Deployment Date",
            deploymentDepartment: "Deployment Department",
            assignedUserEmployeeNumber: "Assigned User / Employee Number",
            userAgreementSignedUrl: "User Agreement Signed URL",
          },
          transportAndMovement: {
            deliveryTransferDate: "Delivery/Transfer Date",
            sourceLocation: "Source Location",
            destinationLocation: "Destination Location",
            transportBy: "Transport By",
            transportReason: "Transport Reason",
            transportStatus: "Transport Status",
          },
          upgradeRedeployment: {
            refreshDecisionDate: "Refresh Decision Date",
            refreshReason: "Refresh Reason",
            resetWipeDate: "Reset Wipe Date",
            redeploymentDate: "Redeployment Date",
            newAssignedUser: "New Assigned User",
            sourceAssetId: "Source Asset ID",
          },
          maintenanceRepair: {
            incidentFailureId: "Incident Failure ID",
            failureDate: "Failure Date",
            failureDescription: "Failure Description",
            repairRequestDate: "Repair Request Date",
            repairCompletedDate: "Repair Completed Date",
            technician: "Technician",
            vendor: "Vendor",
            repairCost: "Repair Cost",
            replacementAssetId: "Replacement Asset ID",
            repairDescription: "Repair Description",
          },
          retirementDisposal: {
            disposalDecisionDate: "Disposal Decision Date",
            disposalMethod: "Disposal Method",
            disposalDate: "Disposal Date",
            dataWipeDate: "Data Wipe Date",
            wipeMethod: "Wipe Method",
            disposalCertificateAttached: "Disposal Certificate Attached",
            accountingDeregistrationDate: "Accounting Deregistration Date",
            disposalReason: "Disposal Reason",
            accountingDeregistrationReason: "Accounting Deregistration Reason",
          },
          planningBudgeting: {
            procurementPlanId: "Procurement Plan ID",
            procurementPurpose: "Procurement Purpose",
            plannedQuantity: "Planned Quantity",
            planningDepartment: "Planning Department",
            requester: "Requester",
            budgetAllocation: "Budget Allocation",
            vendorCandidate: "Vendor Candidate",
            evaluationNotes: "Evaluation Notes",
          },
          procurementAcquisition: {
            assetIdInventoryId: "Asset ID Inventory ID",
            purchaseDate: "Purchase Date",
            vendorSupplierName: "Vendor Supplier Name",
            procurementType: "Procurement Type",
            purchaseCostCurrency: "Purchase Cost Currency",
            purchaseCostTaxExcluded: "Purchase Cost (Tax Excluded)",
            purchaseCostTaxIncluded: "Purchase Cost (Tax Included)",
            modelNumber: "Model Number",
            productName: "Product Name",
            serialNumber: "Serial Number",
            warrantyStartDate: "Warranty Start Date",
            warrantyExpiryDate: "Warranty Expiry Date",
            maintenanceContractId: "Maintenance Contract ID",
            purchaseCondition: "Condition",
          },
          usageOperation: {
            usageStartDate: "Usage Start Date",
            plannedReturnDate: "Planned Return Date",
            loginIdDeviceAccount: "Login ID Device Account",
            operationalStatus: "Operational Status",
            securityCompliance: "Security Compliance",
            storageUsage: "Storage Usage",
            batteryWearLevel: "Battery Wear Level",
            monthlyDataUsage: "Monthly Data Usage",
          },
          leaseContract: {
            contractId: "Contract ID",
            contractNo: "Contract Number",
            contractStartDate: "Contract Start Date",
            contractEndDate: "Contract End Date",
            monthlyLeaseFee: "Monthly Lease Fee",
            deviceIntroductionDate: "Device Introduction Date",
            deviceProcurementPrice: "Device Procurement Price",
            deviceMonthlyLeaseFee: "Device Monthly Lease Fee",
          },
          users: {
            userName: "User Name",
            userOrganization: "User Organization",
            employeeNumber: "User Employee Number",
            fullNameKanji: "Full Name (Kanji)",
            fullNameEnglish: "Full Name (English)",
            loginId: "Login ID / Account ID",
            emailAddress: "Email Address",
            phoneNumber: "Phone Number",
            workType: "Work Type",
            employmentStatus: "Employment Status",
            departmentName: "Department Name",
            teamGroupName: "Team / Group Name",
            departmentCode: "Department Code",
            jobTitle: "Job Title",
            officeLocation: "Office Location",
            managerSupervisor: "Manager / Supervisor",
            assignmentStartDate: "Assignment Start Date",
            expectedReturnDate: "Expected Return Date",
            actualReturnDate: "Actual Return Date",
            registeredBy: "Registered By",
            usageAgreementSigned: "Usage Agreement Signed",
            usageStatus: "Usage Status",
            usageType: "Usage Type",
            usageLocation: "Usage Location",
            usageRestrictions: "Usage Restrictions",
            primarySecondaryDevice: "Primary / Secondary Device",
            personInCharge: "Person in charge",
          },
          responsiblePerson: {
            responsiblePersonName: "Responsible Person Name",
            employeeNumber: "Responsible Person Employee Number",
            responsibleDepartment: "Responsible Department",
            scopeOfResponsibility: "Scope of Responsibility",
            scopeOfResponsibilityPlaceholder: "Enter scope of responsibility",
            responsibleSite: "Responsible Site",
            numberOfAssetsManaged: "Number of Assets Managed",
            lastAuditDate: "Last Audit Date",
            physicalVerifiedFlag: "Physical Verified Flag",
            registeredBy: "Registered By",
            ownerEmployeeNumber: "Owner Employee Number",
            ownerName: "Owner Name",
            ownerDepartment: "Owner's Department",
            ownerCompany: "Owner's Company",
            ownershipStartDate: "Ownership Start Date",
            expectedReturnDate: "Expected Return Date",
            assetId: "Asset ID",
            deviceTag: "Device Tag",
            deviceType: "Device Type",
            ownerConfirmedFlag: "Owner Confirmed Flag",
            responsibleConfirmedFlag: "Responsible Confirmed Flag",
            notes: "Notes",
            assignmentStartDate: "Assignment Start Date",
          },
          placement: {
            placementName: "Placement Name",
            placementType: "Placement/Storage Type",
            placementTypeOptions: {
              UNKNOWN: "Unknown",
              FIXED: "Fixed",
              FREE: "Free",
              STOCK: "Stock",
              OTHER: "Other",
            },
            placementDate: "Placement Date",
            siteOfficeName: "Site / Office Name",
            buildingName: "Building Name",
            buildingNamePlaceholder: "Enter building name",
            floorNumber: "Floor Number",
            floorNumberPlaceholder: "Enter floor number",
            areaZoneName: "Area / Zone Name",
            areaZoneNamePlaceholder: "Enter area/zone name",
            deskSeatNumber: "Desk / Seat Number",
            deskSeatNumberPlaceholder: "Enter desk/seat number",
            reasonForPlacement: "Reason for Placement",
            reasonForPlacementPlaceholder: "Enter placement reason",
            labelStickerId: "Label / Sticker ID",
            gpsBleTagId: "GPS / BLE Tag ID",
            placementDocumentLink: "Placement Document Link",
            notes: "Notes",
            from: "From",
            to: "To",
          },
          placementDetail: {
            rackNumber: "Rack Number",
            rackUPosition: "Rack U Position",
            shelfCabinetNumber: "Shelf / Cabinet Number",
            placementWidthCentimeter: "Placement Width",
            placementHeightCentimeter: "Placement Height",
            placementDepthCentimeter: "Placement Depth",
            placementCondition: "Placement Condition",
            physicalEnvironment: "Physical Environment",
            locationPhotoUrl: "Location Photo URL",
          },
          placementStatus: {
            placementStatus: "Placement Status",
            lastPhysicalCheckDate: "Last Physical Check Date",
            verificationMethod: "Verification Method",
            verificationStatusOptions: {
              MATCH: "Match",
              MISMATCH: "Mismatch",
              NOT_CHECKED: "Not Checked",
            },
            placementVerificationStatus: "Placement Verification Status",
            lastUpdatedDate: "Last Updated Date",
          },
          statusAndHealth: {
            batteryLevel: "Battery Level",
            chargingStatus: "Charging Status",
            deviceTemperature: "Device Temperature",
            lastCheckInTime: "Last Check-In Time",
            devicePhotos: "Device Photos",
            devicePhotoUploadDialog: {
              uploadPhoto: "Upload Photo",
              photoLabel: "Label",
              photoLabelPlaceholder: "Enter label...",
            },
          },
          policiesAndProfiles: {
            appliedPolicyName: "Applied Policy Name",
            dateApplied: "Date Applied",
            wifiVpnCertificateProfiles: "Wi-Fi / VPN / Certificate Profiles",
            restrictions: "Restrictions (USB Disable, External Media Block)",
            scriptProfileExecutionHistory: "Script / Profile Execution History",
          },
          // MDM Integration Sections
          mdm: {
            // Data Source Section
            dataSource: {
              linkedApp: "Linked Software",
            },
            // Hardware Information Section
            hardware: {
              deviceType: "Device Type",
              deviceName: "Device Name",
              manufacturer: "Manufacturer",
              modelNumber: "Model Number",
              serialNumber: "Serial Number",
              processorName: "CPU",
              storageCapacity: "Total Storage Capacity",
              ramCapacity: "Total Memory Capacity",
              biosVersion: "BIOS Version",
              batteryLevel: "Battery Level",
              chargingStatus: "Charging Status",
              batteryHealth: "Battery Health",
            },
            // Network Information Section
            network: {
              ipAddress: "IP Address",
              subnetMask: "Subnet Mask",
              gateway: "Gateway",
              dnsServer: "DNS Server",
              wifiSsid: "WiFi SSID",
              bluetoothConnection: "Bluetooth Connection Info",
              wifiMacAddress: "WiFi MAC Address",
              ethernetMacAddress: "Ethernet MAC Address",
              subscriberCarrier: "Carrier",
            },
            // OS Information Section
            os: {
              osType: "OS Type",
              osName: "OS Name",
              osVersion: "OS Version",
              servicePackPatchLevel: "Service Pack/Patch Level",
            },
            // Asset Management Information Section
            assetManagement: {
              assetNumber: "Asset Number",
              purchaseDate: "Purchase Date",
              purchasePrice: "Purchase Price",
              assignedDepartment: "Assigned Department",
              assignmentDate: "Assignment Date",
              currentUser: "Current User",
              managedDeviceOwnerType: "Managed Device Owner Type",
              enrolledDateTime: "Enrollment Date",
              deviceRegistrationState: "Device Registration State",
              lastSyncDateTime: "Last Sync Date",
              userDisplayName: "User Display Name",
              emailAddress: "Email Address",
            },
            // Security Status Section
            security: {
              systemIntegrityProtection: "System Integrity Protection (SIP)",
              firewallSettings: "Firewall Settings",
              diskEncryption: "Disk Encryption",
              passwordPolicyCompliance: "Password Policy Compliance",
              diskEncryptionLabel: "Disk Encryption",
              jailbreakStatusLabel: "Jailbreak Status",
              // Boolean value labels
              diskEncryptionStatus: {
                enabled: "Enabled",
                disabled: "Disabled",
              },
              jailbreakStatus: {
                jailbroken: "Jailbroken",
                notJailbroken: "Not Jailbroken",
              },
              adminPrivileges: "Admin Privileges",
            },
            // Software Information Section
            software: {
              installedApps: "Installed Software",
              appVersion: "Software Version",
              prohibitedAppDetection: "Prohibited Software Detection",
              appUsage: "Software Usage",
            },
          },
        },
        navigation: {
          title: "Device Profile",
          audit: "Audit",
          lifecycle: "Lifecycle",
          planning: "Planning",
          network: "Network",
          security: "Security",
          contract: "Contract",
          sectionTitle: {
            base: "Device ID Information",
            bios: "BIOS",
            gpu: "GPU",
            processor: "Processor",
            ram: "RAM",
            storage: "Storage",
            port: "Port",
            display: "Display",
            battery: "Battery",
            os: "OS",
            network: "Network",
            user: "User",
            responsiblePerson: "Responsible Person",
            placement: "Placement",
            placementDetail: "Placement Detail",
            placementStatus: "Placement Status",
            statusAndHealth: "Status & Health",
            logsAudit: "Logs & Audit",
            provisioningDeployment: "Provisioning & Deployment",
            transportAndMovement: "Transport & Movement",
            upgradeRedeployment: "Upgrade & Redeployment",
            maintenanceRepair: "Maintenance & Repair",
            retirementDisposal: "Retirement & Disposal",
            planningBudgeting: "Planning & Budgeting",
            procurementAcquisition: "Procurement & Acquisition",
            usageOperation: "Usage & Operation",
            networkAndSim: "Network & SIM",
            networkConfiguration: "Network Configuration",
            securityStatus: "Security Status",
            securityConfiguration: "Security Configuration",
            remoteManagementFeatures: "Remote Management Features",
            remoteManagementHistory: "Remote Management History",
            policiesAndProfiles: "Policies & Profiles",
            // MDM Section Titles
            mdmDataSource: "Data Source",
            mdmHardwareInfo: "Hardware Information",
            mdmNetworkInfo: "Network Information",
            mdmOsInfo: "OS Information",
            mdmAssetManagement: "Asset Management Information",
            mdmSecurityStatus: "Security Status",
            mdmSoftwareInfo: "Software Information",
            mdmOperationLog: "Operation Log",
            // Contract
            leaseContract: "Lease Contract",
            // DeviceInventory
            deviceInventory: "Device Inventory",
          },
          button: {
            putIntoMaintenance: "Put in maintenance",
            recoverFromMaintenance: "Recover from maintenance",
            decommission: "Decommission",
            assignDevice: "Assign Device",
            changeStatus: "Change Device Status",
            changeAssignment: "Change Assignment",
            changeResponsiblePerson: "Change Responsible Person",
            changePlacement: "Change Placement",
            assignUser: "Assign User",
            changeUser: "Change User",
            releaseUser: "Release User",
          },
        },
        notRegistered: "Not Registered",
        deviceInventory: {
          title: "Inventory Report",
          reportResult: {
            label: "Inventory Result",
            owned: "Valid",
            lost: "Lost",
            notKnown: "Invalid",
          },
          verificationMethod: {
            label: "Verification Method",
            physicalCheck: "Physical Check",
            scan: "Scan",
            photoRecord: "Photo Record",
            assetTag: "Asset Tag",
            informal: "Informal",
            representativeByStaff: "Representative by Staff",
          },
          deviceCondition: {
            label: "Device Condition",
            good: "Good",
            bad: "Bad",
          },
          lastPhysicalCheckDate: "Last Physical Check Date",
          reportedAt: "Reported At",
          reportedBy: "Reported By",
          memo: "Memo",
        },
        dialog: {
          releaseAssignment: {
            triggerButton: "Release User",
            title: "Release User",
            description:
              "Releasing the user will change the device status from assigned to available.",
            endDate: "End Date",
            endDateRequired: "End Date is required.",
            endDateLessThanStartDate: "End Date must be after {{startDate}}.",
          },
        },
      },
      importCsv: {
        title: "Bulk Add Devices",
        filename: "Devices",
        templateTitle: "New devices",
        updateExisting: "Update existing devices",
        unit: "devices",
        completeLinkButton: "Go to Inventory",
        checkValidColumn: {
          errors: "Errors",
        },
        completeDialog: {
          message: "Successfully Imported!",
          button: "Go to Inventory",
        },
        deviceType: {
          title: {
            computer: "Bulk Add Computer",
            mobile: "Bulk Add Mobile",
            monitor: "Bulk Add Monitor",
            server: "Bulk Add Server",
            other: "Bulk Add Other",
          },
          prepareCsvFile: {
            templateTitle: {
              computer: "New computers",
              mobile: "New mobiles",
              monitor: "New monitors",
              server: "New servers",
              other: "New others",
            },
            updateExisting: {
              computer: "Update existing computers",
              mobile: "Update existing mobiles",
              monitor: "Update existing monitors",
              server: "Update existing servers",
              other: "Update existing others",
            },
          },
          unit: {
            computers: "computers",
            mobiles: "mobiles",
            monitors: "monitors",
            servers: "servers",
            others: "others",
          },
        },
      },
      filters: {
        computer: "Computer",
        deviceTypePlaceholder: "Filter device type...",
        manufacturerPlaceholder: "Filter MFR...",
      },
      overview: {
        pageTitle: "devices/overview",

        // 基本辞書順にフラットに並べる（小文字を原則として使い回せるように）
        assignment: "assignment",
        availableDevices: "available devices",
        devices: "devices",
        discarding: "Discarding/Returning",
        monthlyBilling: "monthly billing",
        onetimeBilling: "one-time billing",
        persons: "persons",
        placement: "placement",
        places: "places",
        purchasing: "Purchasing/Renting",
        recentActivity: "recent activity",
        schedule: "schedule",
        thisMonth: "this month",
        thisWeek: "this week",
        today: "today",
        upcomingRenewals: "upcoming renewal",
        upcomingUpgrades: "upcoming upgrade",
        viewMore: "view more",
      },
      inventory: {
        filterPlaceholder: "Filter devices...",
        pageTitle: "devices/inventory",
        filterDevicePlaceholder: "Filter by devices...",
        addDevice: "Add Device",
        goToProfile: "Go To Profile",
        unassiged: "Unassigned",
        tabs: {
          assigned: "Assigned",
          placed: "Placed",
          available: "Available",
          underMaintenance: "Under Maintenance",
          inDistribution: "In Distribution",
          all: "All devices",
          decommissioned: "Decommissioned",
        },
        status: {
          assigned: "assigned",
          hidden: "hidden",
          maintenance: "maintenance",
          available: "available",
          disposed: "disposed",
        },
        actions: {
          changeAssignee: "Change Assignee",
          dispose: "Dispose",
          delete: "Delete",
          maintain: "Maintain",
          finishMaintain: "Finish Maintain",
          backToAvailable: "Back to Available",
          openMenu: "Open menu",
        },
      },
      add: pagesDevicesAddEn,
      externalItSaas: pagesDevicesExternalItSaasEn,
      file: pagesDevicesFileEn,
      people: {
        filterPlaceholder: "Filter by name, email...",
        pageTitle: "devices/people",
        tabs: {
          all: "All",
          onboarding: "Onboarding",
          offerAccepted: "Offer Accepted",
          offboarding: "Offboarding",
        },
        filters: {
          hasSomeDevice: "Has Some Device",
          equalTo: "equals to",
          moreThan: "more than",
          lessThan: "less than",
          isMoreThan: "is more than",
          isLessThan: "is less than",
          device: "Device",
          model: "Model",
          person: "Person",
          locationOfOffice: "Location Of Office",
          organization: "Organization",
          hiredAt: "Hire At",
          offboardedAt: "Offboarded At",
          selected: "{{value}} selected",
          personallyOwned: "Personally Owned",
          filterOutput: "{{label}} <light>is</light> {{name}}",
          quantityFilterOutput: "{{label}} <light>{{text}}</light> {{name}}",
        },
        addDevice: "Add Device",
        openMenu: "Open Menu",
        changeDevices: "Change Devices",
        unassignAll: "Unassign All",
      },
      settings: {
        pageTitle: "devices/settings/catalog",
        filterCatalogPlaceholder: "Filter catalog...",
        addCatalogButton: "Add Catalog",
        status: {
          active: "Active",
          inactive: "Inactive",
        },
        actions: {
          openMenu: "Open menu",
          copy: "Copy",
          makeInactive: "Make inactive",
          makeActive: "Make active",
          delete: "Delete",
        },
        tabs: {
          catalog: "Catalog",
          inventory: "Inventory",
          people: "People",
          ruleAndPolicy: "Rule & Policy",
        },
        filters: {
          category: "Category",
          brand: "Brand",
          manufacture: "Manufacture",
          status: "Status",
          filterOutput: "{{label}} <light>is</light> {{name}}",
          active: "active",
          inactive: "inactive",
        },
        add: {
          title: "Add Catalog",
          registerButton: "Register",
          basicInformation: "Basic Information",
          successfulMessage: "🎉 Successfully add Catalog!",
          image: "Image",
          name: "Name",
          namePlaceholder: "your device name",
          category: "Category",
          categoryPlaceholder: "Select device category...",
          brand: "Brand",
          optional: "(Optional)",
          brandPlaceholder: "select device brand...",
          manufacture: "Manufacture",
          manufacturePlaceholder: "Select manufacture...",
          warning: "If brand has manufacture, value will be auto filled.",
          dragYourFileHere: "Drag your file here!",
          uploadingWaitAMoment: "Uploading, wait a moment...!",
          uploadSucceeded: "Upload succeeded!",
          chooseAnotherFile: "Choose another file",
          or: "or",
          browseFileButton: "Browse file",
          tryAgain: "Try again",
        },
        deleteCatalogDialog: {
          title: "Delete catalog?",
          content:
            "This catalog and all of its data will be deleted. Do you still want to go ahead and delete?",
          cancelButton: "Cancel",
          permanentlyDeleteButton: "Permanently Delete",
        },
        intoMaintenanceDialog: {
          title: "Put {{name}} in Maintenance?",
          content:
            "You can mark the device as under maintenance and unassign it.\nIf recovered, you can assign from under maintenance list.",
          cancelButton: "Cancel",
          intoMaintenanceButton: "Save",
          startMaintenanceDate: "Maintenance Start Date",
          maintenanceReason: "Reason",
        },
        recoverMaintenanceDialog: {
          title: "Recover {{name}} from Maintenance?",
          content: "Recover the device from maintenance status.",
          cancelButton: "Cancel",
          recoverMaintenanceButton: "Recover",
          endMaintenanceDate: "Maintenance End Date",
          maintenanceReason: "Reason",
        },
        decommissionDialog: {
          title: "Decommission {{name}}?",
          content: "Decommission the device.",
          cancelButton: "Cancel",
          decommissionButton: "Decommission",
          decommissionDate: "Decommission Date",
          decommissionReason: "Reason",
        },
        assignDeviceDialog: {
          title: "Assign Device",
          notAssigned: "Not Assigned",
          selectInputPlaceholder: "Select Member",
          assignmentDate: "Assignment Date",
          unselectedMemberErrorMessage: "Please select a member",
          validFromDate: "Valid From Date",
          selectDatePlaceholder: "Select date",
          unselectedDateErrorMessage: "Please select a date",
        },
        changeDeviceTypeDialog: {
          title: "Changing device type",
          selectPlaceholder: "Select device type...",
          cancelButton: "Cancel",
          saveButton: "Change device type",
          editButton: "Edit",
          alertMessage:
            "Changing the device type will delete the device type specific data: {{ dataName }} for {{ deviceName}}.",
          deviceDataType: {
            software: "Software",
            hardwareProcessor: "Processor",
            hardwareStorage: "Storage",
            hardwareDisplay: "Display",
            hardwareInterface: "Interface",
          },
        },
        orderStatusBanner: {
          title: "Your Order is on the way",
          alreadyReceived: "Already received this device?",
          checkOrder: "Check Order",
          steps: {
            ordered: "Ordered",
            inDistribution: "In distribution",
            received: "Received",
          },
        },
      },
    },
    profile: {
      app: {
        pageTitle: "software/integrations/{{name}} - Overview",
        header: {
          contractStartedOn: "Contract started on",
          contractRenewalDate: "Contract renewal date",
          contractRenewalCycleMonthly: "{{day}} of each month",
          contractRenewalCycleYearly: "Every {{month}} {{day}}",
          in: "In",
          plan: "Plan",
          currencyDisplayFree: "Free",
          currencyDisplayUnpredictable: "Pay as you go",
          cycleText: "{{cycleLength}} {{cycleUnit}}",
          billableUserUnit: " per user / {{cycle}}",
          licenseSeatUnit: " per seat / {{cycle}}",
          fixedUnit: "/ {{cycle}}",
          customApp: "Custom SaaS",
        },
        overview: {
          cards: {
            monthlyCost: "Monthly Cost",
            monthlyCostTooltip:
              "The monthly cost is determined by the total number of users and the billing plan according to the setting. Please note that actual billing may vary.",
            fromLastMonth: "from last month",
            userPeople: "User (People)",
            userTooltip:
              "The term 'People' refers to both employees and contractors within the organization, serving as a reference for the 'User'.",
            monthlyActiveUser: "Monthly Active User",
            monthlyActiveUserTooltip:
              "The percentage of monthly active users is calculated based on whether the user has been active during the current month.",
            renewsOn: "Renews On",
            monthsLeft: "{{value}} left",
            savings: "Savings",
            savingsTooltip:
              "The savings are calculated based on the monthly cost of the users your organization deactivated promptly for security and cost cut purposes.",
          },
          charts: {
            billingAndCost: "Billing & Cost",
            userGrowth: "User Growth",
            tooltip: {
              costLabel: "Monthly cost: ",
              cumulativeLabel: "Cumulative: ",
              userCountLabel: "User count: ",
            },
            legend: {
              monthlyCost: "Monthly cost ({{scale}})",
              forecastedCost:
                "Forecasted cost based on scheduled new hires ({{scale}})",
              cumulativeCost:
                "Cumulative cost since {{fiscalStartMonth}} ({{scale}})",
              forecastedCumulativeCost:
                "Forecasted cumulative cost based on scheduled new hires ({{scale}})",
              monthlyUsers: "Number of monthly users ({{scale}})",
              forecastedUsers:
                "Forecasted users on scheduled new hires ({{scale}})",
              cumulativeUsers: "Cumulative number of users ({{scale}})",
              forecastedCumulativeUsers:
                "Forecasted cumulative number of users based on scheduled new hires ({{scale}})",
              unitUsers: "users",
            },
          },
          recommendedActions: {
            title: "Recommended Actions",
            emptyTitle: "Looking All Good!",
            emptyDescription: "No recommended actions.",
            importUsers: {
              title: "No users yet!",
              description:
                "Import user data to unlock the full potential of DRESS CODE.",
              button: "Import",
            },
          },
        },
        users: {
          pageTitle: "software/integrations/{{name}} - Users",
          activeUser: "Active User",
          inactiveFor20Days: "Inactive for 20 days",
          filterPeoplePlaceholder: "Filter people...",
          changePerson: "Change Person",
          openMenu: "Open menu",
          tabs: {
            following: "Following",
            unidentified: "Unidentified",
            violatedAssignment: "Violated Assignment",
            violatedAccountRole: "Violated Account Role",
            noUser: "No User",
            inactive: "Inactive",
            alumni: "Alumni",
            allUser: "All user",
            importUserLabel: "Import User",
          },
          changePersonDialog: {
            changePerson: "Change Person",
            from: "From",
            to: "To",
            noPerson: "No Person associated",
            unassignButton: "Unassign",
            cancelButton: "Cancel",
            saveButton: "SaveButton",
            changeAssigneeSuccessfulMessage: "Assignee has been changed!",
            unassignSuccessfulMessage: "Assignee has been removed!",
            selectAssigneePlaceholder: "Select Assignee",
          },
        },
        ruleAndPolicy: pagesProfileAppIdRuleAndPolicyEn,
        settings: {
          pageTitle: "{{name}} - Settings",
          sections: {
            userProvisioning: "User Provisioning",
            customAppDefinition: "Custom SaaS Definition",
            integrationFeatures: "IntegrationFeatures",
            pricingBillingPlan: "Pricing/Billing Plan",
            planDetails: "Plan Details",
            management: "Management",
            authentication: "Authentication",
            samlSso: "SAML / SSO",
            dangerZone: "Danger Zone",
          },
          integrationFeatures: {
            title: "Integration Features",
            function: "Function",
            description:
              "To maximize the benefits of DRESS CODE, it is recommended to enable all integration features.",
            userProvisioning: "User provisioning",
            autoSyncUserGroups: "Auto sync user groups",
            tooltip: {
              isNotImplemented: "{{feature}} is not provided for {{appName}}",
              isNotProvidedForPlan:
                "This feature is not available in DRESS CODE for your current {{appName}} plan.",
            },
            requiredReAuthentication:
              "Re-authentication is required due to insufficient authentication scopes.",
            functions: {
              create: "Create",
              reactivate: "Reactivate",
              deactivate: "Deactivate",
            },
            manualUpdate: {
              title: "Manual update",
              description: "You can manually update the user data.",
            },
          },
          customAppDefinition: {
            title: "Custom SaaS Definition",
            description: "You can manually update the user data.",
            editButton: "Edit",
            appNameLabel: "Software Name",
            appUrlLabel: "Software url",
            appCategoryLabel: "Software category",
            appLogoLabel: "Software logo",
            fileSizeError: "File size must be less than 1MB",
            notSet: "Not set",
            save: "Save",
            reloadMessage: "Avatar changes will take effect after reloading.",
          },
          pricingBillingPlan: {
            title: "Pricing/Billing Plan",
            description:
              "DRESS CODE is unable to modify the pricing and billing plans for {{name}}. For any changes to your plan or billing details, please visit their pricing page directly.",
            goToAppWebsite: "Go to the {{name}} website",
          },
          planDetails: {
            title: "Plan Details",
            edit: "Edit",
            save: "Save",
            alertTitle: "Plan Details needs to be updated manually",
            alertContent:
              "DRESS CODE is unable to monitor updates to the pricing and billing plans for {{name}}. Please inform us if you make any changes.",
            plan: "Plan",
            planPlaceholder: "Select plan...",
            subscription: "Subscription",
            subscriptionPlaceholder: "Select subscription...",
            useCustomPrice: "Use custom price",
            licenseSeat: "License Seat",
            contractRenewalDate: "Contract Renewal Date",
            currency: {
              label: "Currency",
              placeholder: "Select currency",
            },
          },
          authentication: {
            title: "Authentication",
            edit: "Edit",
            tenant: "Tenant / Workspace",
            tenantDescription:
              "Tenant / Workspace is a unique identifier for your customer (or company) on the connected Software. If it is not provided by the connected Software, DRESS CODE will assign a random ID.",
            tenantId: "ID",
            tenantName: "Name",
            update: "Update",
            updateAuthentication: "Update Authentication",
            authMethod: {
              OAUTH: {
                label: "OAuth 2.0",
                description:
                  "OAuth, or open authorization, allows you to authorize DRESS CODE to interact with {{app_name}} on your behalf without revealing your password.",
              },
              API_KEY: {
                label: "API Key",
                description:
                  "Please refer to the {{app_name}}’s website for the appropriate key to use.",
              },
              ID_PASSWORD: {
                label: "ID and password",
                description:
                  "Use the administrator account to ensure the integration features work correctly.",
              },
              NONE: {
                label: "No authentication required",
                description: "No authentication required for integration.",
              },
            },
          },
          mdm: {
            title: "MDM Configuration",
            description:
              "Configure Mobile Device Management settings for Microsoft Intune integration.",
            updateAuthentication: "Update Authentication",
            labels: {
              tenantId: "Directory (tenant) ID",
              clientId: "Application (client) ID",
              clientSecret: "Secret ID",
            },
            updateDialog: {
              title: "Update MDM Authentication",
              description:
                "Enter authentication credentials for Microsoft Intune integration.",
              placeholders: {
                tenantId: "72f988bf-86f1-41af-91ab-2d7cd011db47",
                clientId: "1950a258-227b-4e31-a9cf-717495945fc2",
                clientSecret: "Enter secret ID",
              },
              buttons: {
                updating: "Updating...",
                updateAuthentication: "Update Authentication",
              },
            },
            toast: {
              updateSuccess: "MDM authentication updated successfully",
              updateError: "Failed to update MDM authentication",
            },
          },
          samlSSO: {
            title: "SAML / SSO",
            description:
              "Security Assertion Markup Language (SAML) and Single Sign-On (SSO) ensure secure and streamlined authentication for your users.",
            recommend: "Recommended",
            enableSSO: "Enable SSO",
            disableSSO: "Disable SSO",
            placeholder: "url to direct users",
          },
          dangerZone: {
            title: "Danger Zone",
            changeAuthenticationMethod: "Change authentication method",
            changeAuthenticationMethodDescription:
              "Modify the way {{name}} authenticate the DRESS CODE to access the system. Please note that changing authentication methods may cause issues with integration features.",
            changeAuthenticationButton: "Change the authentication method",
            deactivateIntegration: "Deactivate integration",
            deactivateIntegrationDescription:
              "Deactivating the integration may affect services that rely on the integration.",
            deactivateIntegrationButton: "Deactivate this integration",
            reactivateIntegration: "Reactivate integration",
            reactivateIntegrationDescription:
              "Reactivating integration may trigger integration features, such as user accounts provisioning.",
            reactivateIntegrationButton: "Reactivate this integration",
            deleteData: "Delete Data",
            deleteDataDescription:
              "Permanently remove all your data managed by this integration. This action is irreversible.",
            deleteDataButton: "Delete all the data",
            deleteDataButtonTooltipContent:
              "This operation is possible after the  deactivate integration",
            deleteDialog: {
              title: "Delete data",
              description:
                "Permanently remove all your data managed by this integration. This action is irreversible.",
              deleteButton: "Permanently Delete",
              cancel: "Cancel",
              successfulMessage: "Integration deactivated",
            },
            deactivateDialog: {
              title: "Are you sure to deactivate Integration?",
              description:
                "Deactivating the integration may affect services that rely on the integration.",
              deactivateButton: "Deactivate",
              cancel: "Cancel",
              successfulMessage: "✅ Integration deactivated",
            },
            reactiveDialog: {
              title: "Are you sure to reactivate Integration?",
              description:
                "Reactivating integration may trigger integration features, such as user accounts provisioning.",
              reactivateButton: "Reactivate",
              cancel: "Cancel",
              successfulMessage: "✅ Integration reactivated",
            },
            changeAuthDialog: {
              title: "Change authentication methods",
              from: "From",
              to: "To",
              oauth: "OAuth 2.0",
              oauthInfo:
                "Please use the administrator user account to authenticate.",
              proceedToAuthenticate: "Proceed to authenticate",
              apiKey: "API Key",
              save: "Save",
              idAndPassword: "ID and password",
              password: "Password",
            },
          },
        },
      },
      software: {
        pageTitle: "software/{{name}} - Overview",
        header: {
          assignedTotal: "Assigned / Total",
          status: "Status",
          renewalDate: "Renewal date",
        },
      },
    },
    vendor: {
      marketplace: pagesVendorMarketplaceEn,
    },
    places: pagesPlacesEn,
    networks: pagesNetworksEn,
    starlinks: pagesStarlinksEn,
    equipment: pagesEquipmentEn,
    fleets: pagesFleetsEn,
    idManagements: pagesIdManagementsEn,
    licenses: pagesLicensesEn,
    timeAndAttendance: pagesTimeAndAttendanceEn,
    certification: pagesCertificationEn,
  },
  individualPages: individualPagesEn,
  domain: {
    appUser: domainAppUserEn,
    device: domainDeviceEn,
    person: domainPersonEn,
    qrScanner: domainQrScannerEn,
    workerTypeRule: domainWorkerTypeRuleEn,
  },
  features: {
    boeTask: boeTaskEn,
    formFactory: formFactoryEn,
    operationArchives: operationArchivesEn,
    operationPackage: operationPackageEn,
    operationPackageInstance: operationPackageInstanceEn,
    operationPackageConfig: operationPackageConfigEn,
    history: {
      historyItem: {
        header: {
          button: {
            text: "Detail",
          },
        },
      },
      floatingActionButton: {
        button: {
          text: "Snapshot history",
        },
      },
      error: {
        invalidDataFormat: "Error: History data format is invalid",
      },
    },
  },
  component: {
    appCategoryFilterChip: {
      placeholder: "Search by category",
      noResult: "No results found",
    },
    appIntegrationPreviewContent: {
      goToProfile: "go to profile",
    },
    myAccountPopover: {
      noMember: "(No profile)",
      accountSettingsButton: "Account settings",
      signOutButton: "Sign out",
      signIn: "Sign In",
      helpCenter: "Help Center",
      termOfService: "Terms of Service",
      privacyPolicy: "Privacy Policy",
      operator: "Operator",
      individual: "Member",
      serviceAccount: "Service Account",
      switchToIndividualPage: "Switch to member page",
      switchToOperatorPage: "Switch to operator page",
    },
    addressForm: componentsFormAddressFormEn,
    appCard: {
      goToProfile: "Go To Profile",
    },
    flowNode: componentsFlowNodeEn,
    input: {
      optional: "(Optional)",
    },
    inputPhoneNumber: {
      searchByCountryName: "Search by country name",
      noResultsMessage: "No results found",
    },
    inputPostalCode: {
      placeholder: "",
    },
    inputYear: {
      placeholder: "Select year",
      suffix: "",
    },
    inputMonth: {
      placeholder: "Select month",
      january: "1 - January",
      february: "2 - February",
      march: "3 - March",
      april: "4 - April",
      may: "5 - May",
      june: "6 - June",
      july: "7 - July",
      august: "8 - August",
      september: "9 - September",
      october: "10 - October",
      november: "11 - November",
      december: "12 - December",
    },
    inputDay: {
      placeholder: "Select day",
      suffix: "",
    },
    organizationInfo: {
      locationMissing: "If flag is missing, please re-signin.",
    },
    selectAvatar: {
      unassigned: "Unassigned",
    },
    filterButton: {
      filters: "{{val}} Filters",
      filter: "Filter",
    },
    filterSheet: {
      title: "Edit filter",
      clearAll: "Clear all",
      addFilter: "Add filter",
      apply: "Apply",
    },
    filterSheetButton: {
      count_zero: "Filter",
      count_one: "{{count}} Filter",
      count_other: "{{count}} Filters",
    },
    filterTrans: {
      is: "<sub /> <muted>is</muted> <obj />",
      contains: "<sub /> <muted>contains</muted> <obj />",
    },
    changePasswordDialog: {
      title: "Change your password",
      notMatchPasswordError: "The passwords you entered do not match.",
      successfulMessage: "Password change successful.",
      oldPassword: "Old Password",
      oldPasswordPlaceholder: "Old Password",
      newPassword: "New Password",
      newPasswordPlaceholder: "New Password",
      confirmPassword: "Confirm Password",
      confirmPasswordPlaceholder: "Confirm New Password",
      submitButton: "Change Password",
    },
    ConfirmDialog: {
      title: "{{action}} {{resource}}",
    },
    selectCountry: {
      placeholder: "Select country",
      searchPlaceholder: "Search by country name",
      noResultsMessage: "No results found",
    },
    selectStateProvince: {
      placeholder: "Select state/province",
      searchPlaceholder: "Search by State or Province name",
      noResultsMessage: "No results found",
    },
    sidebar: {
      // Home
      operationCockpit: "Operation Cockpit",
      cockpit: "Cockpit",
      businessEvent: "Business Event",
      marketplace: "Marketplace",

      // Force
      force: "Force",

      // HR Force
      people: "People",
      laborCore: "Labor Core",
      contractorCore: "Contractor Core",
      timeAndAttendance: "Time & Attendance",
      organization: "Organization",
      organizationPlanning: "Organization Planning",
      publicIds: "Public IDs",

      // IT Force
      apps: "Software",
      software: "Software",
      devices: "Devices",
      idAndAccess: "ID & Access",
      licenses: "Licenses",
      networks: "Networks",
      itOperationCore: "IT Operation Core",

      // GA Force
      places: "Places",
      equipment: "Equipment",
      gaOperationCore: "GA Operation Core",
      fleet: "Fleet",
      starlinks: "Starlink",

      // LI Force
      contract: "Contract",

      // Settings
      settings: "Settings",
      userAccounts: "User Accounts",
      permissionAndRoles: "Permission & Roles",

      closeSidebar: "Close Sidebar",
    },
    statusBar: {
      statusAndResourceConnector: "{{resource}} is a {{status}}",
    },
    dataTable: {
      noResult: "No results.",
      placeholder: "Search and display results",
      pagination: {
        rows: "{{count}} rows",
        pageOrder: "Page {{page}} of {{total}}",
        rowsPerPage: "Rows per page",
        goToFirstPage: "Go to first page",
        goToPreviousPage: "Go to previous page",
        goToNextPage: "Go to next page",
        goToLastPage: "Go to last page",
      },
      columnAction: {
        sortAsc: "Asc",
        sortDesc: "Desc",
        hide: "Hide",
      },
      headers: {
        xxx: "-",
        anchorDate: "Anchor Date",
        operationPackage: "Operation Package",
        job: "Job",
        code: "Code",
        hrMasterCode: "Code",
        position: "Position",
        positions: "Position",
        rank: "Rank",
        department: "Department",
        departments: "Department",
        departmentAndPositions: "Department / Position",
        owner: "Owner",
        parent: "Parent",
        person: "Person",
        jobType: "Job type",
        contractNo: "Contract No.",
        contractTitle: "Contract Title",
        contractStatus: "Contract Status",
        contractStartDate: "Contract Start Date",
        contractEndDate: "Contract End Date",
        contractHierarchy: "Contract Hierarchy",
        jobTypes: "Job type",
        workerType: "Worker type",
        network: "Network",
        placement: "Placement",
        employmentType: "Employment type",
        boardMemberType: "Board type",
        contractorType: "Contractor type",
        collaboratorType: "Collaborator type",
        place: "Place",
        places: "Place",
        assignedLocations: "Assigned Location",
        office: "Office",
        equipment: "Equipment",
        joinedOn: "Joining date",
        leftOn: "Leaving date",
        contractDateFrom: "Contract start date",
        contractDateTo: "Contract end date",
        displayOrder: "Display order",
        devices: "Devices",
        apps: "Software",
        actions: "Actions",
        nationalIdType: "National ID Type",
        issueDate: "Issue Date",
        expiryDate: "Expiry Date",
        fileName: "File Name",
        lastUpdater: "Last Updater",
        lastUpdateDate: "Last Update Date",
        startDate: "Start Date",
        endDate: "End Date",
        status: "Status",
        app: "Software",
        pricingPlan: "Pricing Plan",
        monthlyFee: "Monthly Fee",
        activeUser: "Active User",
        licenseSeat: "License Seat",
        assignedTotal: "Assigned / Total",
        shadowId: "Shadow Id",
        pricingModel: "Pricing Model",
        contractRenewalDate: "Contract Renewal Date",
        releaseDate: "Release Date",
        endOfSupportDate: "End of Support Date",
        repoUrl: "Repo URL",
        installedDevices: "Installed Devices",
        lastSyncedAt: "Last Synced At",
        people: "People",
        networks: "Networks",
        networkType: "Network Type",
        purpose: "Usage Purpose",
        destination: "Destination",
        connectionType: "Connection Type",
        ipAddress: "IP Address",
        adminContact: "Admin Manager",
        organizations: "Organizations",
        fleetName: "Fleet Name",
        fleetId: "Fleet ID",
        fleetType: "Type",
        fleetCategory: "Category",
        manufacturer: "Manufacturer",
        model: "Model",
        assignedPlace: "Assigned Place",
        hiredAt: "Hired At",
        offboardedAt: "Offboarded At",
        device: "Device",
        devicePlaced: "Device Placed",
        assignedTo: "Assigned To",
        previousAssignedTo: "Previous Assigned To",
        assignedAt: "Assigned At",
        previousAssignedDuration: "Previous Assigned Duration",
        assetNumber: "Asset Number",
        inServiceAt: "In Service At",
        procurementDate: "Procurement Date",
        procurementType: "Procurement Type",
        maintenanceStartDate: "Maintenance Start Date",
        maintenanceReason: "Maintenance Reason",
        disposedAt: "Disposed At",
        disposedMemo: "Disposed Memo",
        name: "Name",
        description: "Description",
        severtiy: "Severity",
        priority: "Priority",
        category: "Category",
        brand: "Brand",
        browser: "Browser",
        updated: "Updated",
        appUser: "Account",
        rule: "Rule",
        appUserRole: "Account role",
        correctRole: "Correct Role",
        appUserStatus: "Status",
        appUserDisplayName: "Display Name",
        createdOn: "Created On",
        deactivatedOn: "Deactivated On",
        lastActivity: "Latest Activity",
        configuredMfa: "Configured MFA",
        action: "Action",
        suggestedAction: "Suggested Action",
        user: "User Account",
        tag: "Tag",
        version: "Version",
        installedAt: "Installed At",
        assetTag: "Asset Tag",
        assignee: "Assignee",
        assignmentDate: "Assignment Date",
        lastAssignmentDate: "Last Assignment Date",
        deviceType: "Device Type",
        deviceMemo: "Memo",
        previousAssignee: "Previous Assignee",
        ram: "RAM",
        storage: "Storage",
        displaySize: "Display Size",
        assignedDate: "Assigned Date",
        mdmApp: "MDM App",
        sim: "SIM",
        createdAt: "Created At",
        lastDetected: "Last detection",
        lastSignedInAt: "Last Signed In At",
        personId: "Person ID",
        employeeNumber: "Employee Number",
        familyName: "Last Name",
        middleName: "Middle Name",
        givenName: "First Name",
        familyNamePronunciation: "Last Name (Pronunciation)",
        middleNamePronunciation: "Middle Name (Pronunciation)",
        givenNamePronunciation: "First Name (Pronunciation)",
        sex: "Gender",
        personContactEmail1: "Personal Info_Email (Primary)",
        personContactEmail2: "Personal Info_Email (Secondary)",
        personContactPhoneCountryCode:
          "Personal Info_Primary Phone (Country Code)",
        personContactPhone: "Personal Info_Primary Phone",
        primaryWorkerEmail: "Employee Info_Email (Primary)",
        secondaryWorkerEmail: "Employee Info_Email (Secondary)",
        jobCompetencyCode: "Job Competency Code",
        jobCompetency: "Job Competency",
        joiningDate: "Start Date",
        leftOnDate: "Retirement Date",
        workerContractType: "Worker Contract Type",
        deviceId: "Device ID",
        deviceCategory: "Device Category",
        deviceStatus: "Device Status",
        deviceName: "Name",
        deviceModel: "Model",
        serialNumber: "Serial Number",
        deviceTag: "Inventory ID",
        memo: "Memo",
        procurementSupplier: "Procurement Supplier",
        troubledDate: "Troubled Date",
        personalOwnerWorkerNumber: "Personal Owner Worker Number",
        personalOwnerName: "Personal Owner Name",
        userWorkerNumber: "User Worker Number",
        userWorkerName: "User Worker Name",
        placementDate: "Placement Date",
        mdmDeviceId: "MDM Device ID",
        isFixedAsset: "Is Fixed Asset",
        isComputer: "Is Computer",
        computerType: "Computer Type",
        osPlatform: "OS Platform",
        osName: "OS Name",
        osBuild: "OS Build",
        totalRamMB: "Total RAM (MB)",
        totalStorageMB: "Total Storage (MB)",
        isMonitor: "Is Monitor",
        sizeInInch: "Size (Inch)",
        resolutionWidth: "Resolution (Width)",
        resolutionHeight: "Resolution (Height)",
        leavingDate: "Leaving Date",
        personalContact: "Personal Contact",
        lastUpdatedAt: "Last Updated At",
        lastEmploymentType: "Last Employment Type",
        lastBoardType: "Last Board Type",
        lastContractorType: "Last Contractor Type",
        lastCollaboratorType: "Last Collaborator Type",
        lastWorkforceType: "Last Worker Type",
        lastJobTypes: "Last Job Types",
        lastDepartmentAndPositions: "Last Department / Position",
        lastPlaces: "Last Places",
        lastAssignedLocations: "Last Assigned Location",
        startingDate: "Starting Date",
        currentDevices: "Current Devices",
        currentApps: "Current Software",
        personType: "Worker Type",
        activationDate: "Activation Date",
        email: "Email",
        invitedDate: "Invited Date",
        isExpired: "Is Expired",
        displayName: "Display Name",
        role: "Role Name",
        isBillingUser: "Is Billing User",
        deactivatedAt: "Deactivated At",
        mfaStatus: "MFA Status",
        title: "Title",
        orderedBy: "Ordered By",
        vendor: "Vendor",
        orderNumber: "Order No.",
        orderedByPerson: "Ordered by",
        customer: "Customer",
        supplier: "Supplier",
        acceptedAt: "Accepted at",
        deliveryDate: "Delivery date",
        password: "Password",
        placedDate: "Placed Date",
        placeName: "Place Name",
        placeCode: "Place Code",
        placeStatus: "Status",
        placeContact: "Contact",
        placeWebsite: "Website",
        placeAddress: "Address",
        placeEstablishedDate: "Established Date",
        placeRole: "Role",
        placeRoleIsPrimary: "Is Primary",
        software: "Software",
        equipmentType: "Equipment Type",
        equipmentItem: "Equipment Item",
        equipmentModel: "Model",
        equipmentSerialNumber: "Serial Number",
        equipmentAssetTag: "Asset Management Number/Asset Tag",
        equipmentAssignedPerson: "Assigned To",
        equipmentAssignedPlace: "Location",
        starlinkUserTerminalId: "User Terminal nickname / ID",
        starlinkPlaceId: "Placement/Vehicle",
        starlinkServiceLineNumber: "Service Line Name / Number",
        starlinkNetworkName: "Networks",
        alertUserTerminal: "User terminal",
        alertTitle: "Alert title",
        alertType: "Alert type",
        alertDescription: "Description",
        idManagement: {
          loginId: "ID",
          matchType: "ID Type",
          person: "Person",
          workerType: "Worker Type",
          workerStatus: "Status",
          workerContractType: "Contract Type",
          groupType: "Group Type",
          groupTitle: "Group Title",
          software: "Software",
        },
        attendance: {
          date: "Date",
          person: "Person",
          workPlace: "Work Place",
          clockIn: "Clock In",
          clockOut: "Clock Out",
          totalHours: "Total Hours",
          workingDays: "Working Days",
          breakTime: "Break Time",
          errorCount: "Error Count",
          status: "Status",
        },
        MdmOperationLog: {
          type: "Log Type",
          detail: "Details",
          date: "Date/Time",
          location: "Location",
        },
        MdmAppUsage: {
          appName: "Software Name",
          usageTime: "Usage Time",
          lastUsed: "Last Used",
        },
        hierarchyLevel: "Hierarchy Level",
        hierarchyLabel: "Hierarchy Name",
        environment: "Environment",
        responsiblePerson: "Responsible Person",
        ...componentsDataTableEn,
      },
      viewOptions: {
        toggleColumns: "Toggle Columns",
      },
      cells: {
        AppUserCell: {
          noName: "(No name)",
          noUser: "No User",
        },
        AssignmentRuleCell: {
          following: "Following",
          violated: "Violated",
          incorrectRole: "Incorrect Role",
          unknown: "Unknown",
          noUser: "No User",
        },
        PersonCell: {
          noPerson: "No Person",
          unknownPerson: "(Unknown)",
        },
        MultiValueCell: {
          primary: "Primary",
          hrPrimary: "Primary",
        },
        IntegratedAppsCell: {
          goToProfile: "Go to profile",
          notSetAppName: "(Not set)",
          notSetRoleName: "(Not set)",
        },
        DevicePropertyCell: {
          computer: "Computer",
          other: "Other",
          purchase: "Purchase",
          lease: "Lease",
          rental: "Rental",
        },
      },
    },
    comingSoon: {
      heading: "Exciting New Feature Coming Soon!",
      description:
        "We are working diligently to bring this feature to you. Stay tuned for updates!",
      close: "Close",
      summaryStatTitle: "This Feature Coming Soon!",
    },
    richDatePicker: {
      tabs: {
        presets: {
          title: "Presets",
          last: "Last",
          over: "Over",
          lastWeek: "Last week",
          lastMonth: "Last month",
          last3Months: "Last 3 months",
          lastYear: "Last year",
          last2Years: "Last 2 years",
          last3Years: "Last 3 years",
          overAWeekAgo: "Over a week ago",
          overAMonthAgo: "Over a month ago",
          over3MonthsAgo: "Over 3 months ago",
          overAYearAgo: "Over a year ago",
          over2YearsAgo: "Over 2 years ago",
          over3YearsAgo: "Over 3 years ago",
        },
        custom: {
          title: "Custom",
          today: "today",
          yesterday: "yesterday",
          lastMonday: "last monday",
          daysAgo7: "7 days ago",
          monthAgo1: "1 month ago",
          tomorrow: "tomorrow",
          nextMonday: "next monday",
          daysLater7: "7 days later",
          monthLater1: "1 month later",
          andAllPrecedingDays: "and all preceding days",
          andAllFollowingDays: "and all following days",
          type: {
            on: "On",
            before: "Before",
            after: "After",
            range: "Between",
          },
        },
      },
      tooltip: {
        explanation1:
          "“Last {X}” refers to the {X} immediately preceding the current one.",
        explanation2:
          "“Over {Y} ago” refers to any day before the {Y} that just ended.",
        example:
          "When 21st is today, “last week” and “over a week ago” are illustrated as follows.",
      },
      cancelButton: "Cancel",
      applyButton: "Apply",
      placeholder: "Select date",
      display: {
        before: "Before {{date}}",
        over: "Over {{date}} ago",
        after: "After {{date}}",
        range: "{{start}} to {{end}}",
      },
      dateInput: {
        label: "Date input",
        clear: "Clear date",
        invalidDate: "Invalid date format",
      },
    },
    ConditionEditorGrid: {
      where: "Where",
      select: "Select",
      number: "Number",
      is: "is",
      isAnyOf: "isAnyOf",
      and: "And",
      or: "Or",
      delete: "Delete",
      copy: "Copy",
      addCondition: "Add condition",
      selectPlaceholder: "Select...",
      noFrameworkFound: "No framework found.",
      moreConditions: "{{value}} more conditions",
    },
    dialog: {
      form: {
        optional: "(Optional)",
      },
    },
    GlobalErrorDialog: {
      title: "Something went wrong",
      message: "Sorry for the trouble.\nIf you keep having issues, contact us.",
      goBackButton: "Go back",
    },
    ForbiddenApiErrorDialog: {
      title: "You are not authorized to access this page.",
      message: "Please contact your administrator.",
      noAccessableMessage: "You do not hold any access permissions.",
      goBackHomeStaffButton: "Go back to staff top",
      goBackHomeIndividualButton: "Go back to individual top",
    },
    Combobox: componentsComboboxEn,
    DatePicker: {
      placeholder: "dd/mm/yyyy",
    },
    MonthPicker: {
      placeholder: "mm/yyyy",
    },
    NotFound: {
      title: "Not found",
      description:
        "The page you're looking for doesn't exist or may have moved.",
      backToHome: "Back to home",
    },
    DropZone: {
      csv: {
        dropZoneTitle: "Drop CSV file here",
        dropZoneSubTitle: "or click to upload",
      },
      image: {
        dropZoneTitle: "Click here or drag file to upload",
        imageFileOnly: "(png, jpeg, svg)",
      },
      file: {
        dropActiveMessage: "Drop files here",
        dropInactiveMessage: "Drag & drop files or click to select",
      },
      errorTitle: "Error",
    },
    Password: {
      showPassword: "Show Password",
    },
    PersonPreviewContent: {
      goToProfile: "Go to profile",
    },
    shadowItAppFilterChip: {
      placeholder: "Search by software",
      noResult: "No results found",
    },
    unknownUserFilterChip: {
      placeholder: "Search by user",
      noResult: "No results found",
      only: "Only unknown",
      include: "Include unknown",
      exclude: "Exclude unknown",
    },
  },
  /** どの画面でも汎用的に用いられる用語のみを定義 */
  common: {
    hasValue: "Yes",
    hasNoValue: "No",
    brand: "DRESS CODE",
    comparison: {
      orMore: "or more",
      orLess: "or less",
      lessThan: "less than",
      moreThan: "more than",
      under: "under",
    },
    date: commonDateEn,
    dateOfBirth: "Date of birth",
    sex: {
      MALE: "Male",
      FEMALE: "Female",
      UNKNOWN: "Unknown",
    },
    gender: {
      MALE: "Male",
      FEMALE: "Female",
      UNKNOWN: "Unknown",
    },
    bloodType: {
      A: "A",
      B: "B",
      AB: "AB",
      O: "O",
      UNKNOWN: "Unknown",
    },
    deviceType: {
      computer: "Computer",
      mobile: "Mobile",
      monitor: "Monitor",
      server: "Server",
      other: "Other",
    },
    workerType: {
      employee: "Employee",
      boardMember: "Board Member",
      contractor: "Contractor",
      collaborator: "Collaborator",
    },
    workerStatus: {
      ON_LEAVE: "On leave",
      ALUMNI: "Alumni",
      ACTIVE: "Active",
    },
    workLocationCondition: {
      ALLOWED: "Allowed",
      NOT_ALLOWED: "Not Allowed",
      LIMITED: "Limited",
    },
    bloodRhFactor: {
      POSITIVE: "+",
      NEGATIVE: "-",
      UNKNOWN: "",
    },
    maritalStatus: {
      SINGLE: "Single",
      MARRIED: "Married",
      DIVORCED: "Divorced",
      WIDOWER: "Widower",
    },
    phoneType: {
      LANDLINE: "Home",
      MOBILE: "Mobile",
    },
    residenceType: {
      OWNED: "Owned",
      RENTED: "Rented",
      COMPANY_HOUSING: "Company Housing",
    },
    action: {
      save: "Save",
      saving: "Saving...",
      submit: "Submit",
      create: "Create",
      reactivate: "Reactivate",
      update: "Update",
      deactivate: "Deactivate",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      permanentlyDelete: "Permanently Delete",
      duplicate: "Duplicate",
      add: "Add",
      approve: "Approve",
      next: "Next",
      back: "Back",
      complete: "Complete",
      export: "Export",
      unassign: "Unassign",
    },
    phone: "Phone",
    email: "Email",
    primary: "Primary",
    optional: "Optional",
    required: "Required",
    unregistered: "Unregistered",
    notAnswered: "Not answered",
    undecided: "Undecided",
    left: "left",
    enDash: "–",
    detail: "Detail",
    navigate: {
      home: "Home",
      goBack: "Go back",
    },
    pleaseSelect: "Please select",
    noOptions: "No options",
    avatarUploadSuccess: "Avatar uploaded successfully",
    avatarUploadFailed: "Avatar upload failed",
    anchorDate: "Anchor Date",
    // TODO:以下のオブジェクトは適切な階層に移動する
    status: {
      assigned: "assigned",
      hidden: "hidden",
      maintenance: "maintenance",
      available: "available",
      disposed: "disposed",
    },
    breadcrumbs: {
      home: "Home",
      apps: "Software",
      integrations: "Integrations",
      software: "Software",
      registry: "Registry",
      devices: "Devices",
      inventory: "Inventory",
      contracts: "Contracts",
      addDevice: "Add Device",
      settings: "Settings",
      catalog: "Catalog",
      addCatalog: "Add Catalog",
      ruleAndPolicy: "Rule & Policy",
      addAssignmentRule: "Add Assignment Rule",
      workforce: "Workforce",
      personProfile: "Profile",
      alumni: "Alumni",
      orders: "Orders",
      permissionAndRoles: "Permission & Roles",
      productPermissions: "Product Permissions",
      peopleGroups: "People Groups",
      roles: "Roles",
      places: "Places",
      idManagement: "ID & Access",
      licenses: "Licenses",
      licenseDetail: "License Detail",
      servicePlan: "Service Plan",
      servicePlanDetail: "Service Plan Detail",
    },
    list: {
      overview: "Overview",
      integrations: "Integrations",
      inventory: "Inventory",
      contracts: "Inventory",
      registry: "Registry",
      people: "People",
      alerts: "Alerts",
      contractAndCost: "Contract & Cost",
      operationActivity: "Operation Activity",
      marketplace: "Marketplace",
      ruleAndPolicy: "Rule & Policy",
      settings: "Settings",
      job: "Job",
      position: "Position",
      workforce: "Workforce",
      peopleGraph: "People Graph",
      salaryPayment: "Salary & Payment",
      community: "Community",
      list: "List",
      store: "Store",
      users: "Users",
      groups: "Groups",
      places: "Places",
      profile: "Profile",
      lifecycle: "Lifecycle",
      history: "History",
      apps: "Software",
      educationAndQualification: "Educ. & Qual.",
      devices: "Devices",
      networks: "Networks",
      publicIds: "Public IDs",
      equipment: "Inventory",
      activity: "Activity",
      system: "Software/Hardware",
      configuration: "Rule & Policy",
      monitoring: "Monitoring",
      alumni: "Alumni",
      control: "Control",
      status: "Status",
      mdm: "MDM",
      files: "Files",
      assignment: "Assignment",
      servicePlan: "Service Plan",
      account: "Account",
      personProfile: {
        personalInformation: "Personal Information",
        publicId: "Public ID",
        employeeInformation: "Employee Information",
        apps: "Software",
        equipment: "Equipment",
      },
      persons: {
        operator: "Staff account",
        individual: "Individual account",
        people: "People",
        ruleAndPolicy: "Rule & Policy",
        settings: "Settings",
      },
      permissionAndRoles: {
        roles: "Roles",
        peopleGroups: "People Groups",
        productPermissions: "Product Permissions",
        help: {
          title: "What is Permission & Roles?",
          description:
            "A Role is defined by a combination of People Groups and Permissions.\nA People Group defines a group of people based on specific conditions. \nPermissions define fine-grained control over access to DRESS CODE`s products, determining which content items are visible, editable, and more.",
        },
      },
      placeAdministrators: "Administrators",
      laborCore: "Labor Core",
      idLists: "ID Lists",
      groupId: "Group ID",
      licenses: {
        inventory: "Inventory",
      },
      software: {
        userAccounts: "Accounts",
        activityMonitoring: "Activity Monitoring",
        detail: "Detail",
        architecture: "Architecture",
        contractsAndCost: "Contracts & Cost",
        rulesAndPolicy: "Rules & Policy",
        settings: "Settings",
      },
    },
    profilePopup: {
      changePassword: "Change Password",
      signOut: "Sign out",
    },
    siPrefixes: {
      K: "K",
      M: "M",
      B: "B",
    },
    readOnly: "Read only",
    country: commonCountryEn,
    /**
     * "ISO 4217" の通貨コードをキーにlabelを生成
     * @see https://www.iban.com/currency-codes
     */
    currency: commonCurrencyEn,
    loading: "Loading...",
    noName: "(No name)",
    noResults: "No results",
    fileItem: componentsFormFileItemEn,
  },
  components: {
    deviceStatusBadge: {
      good: {
        label: "Good",
        description: "Device is functioning normally",
      },
      bad: {
        label: "Bad",
        description: "Issues have been reported with this device",
      },
      unreported: {
        label: "Unreported",
        description: "Inventory report has not been submitted yet",
      },
      count: "{{count}} devices",
    },
    displayStatusBadge: {
      REQUEST_BEFORE: {
        label: "Data Updating",
        description: "Preparing request (data updating)",
      },
      REQUEST_IN_PROGRESS: {
        label: "Requesting",
        description: "Executing self-report request",
      },
      SELF_REPORT_BEFORE: {
        label: "Data Updating",
        description: "Waiting for self-report (data updating)",
      },
      SELF_REPORT_IN_PROGRESS: {
        label: "Reporting",
        description: "Self-report in progress",
      },
      REVIEW_BEFORE: {
        label: "Data Updating",
        description: "Waiting for review (data updating)",
      },
      REVIEW_IN_PROGRESS: {
        label: "Reviewing",
        description: "Review in progress",
      },
      REVIEW_COMPLETED: {
        label: "Completed",
        description: "Review completed",
      },
    },
    reportProxyDialog: {
      title: "Report Proxy",
      targetDevice: "Target Device",
      assignee: "Assignee: {{name}}",
      deviceCondition: "Device Condition",
      conditionGood: "Good - Device is functioning normally",
      conditionBad: "Bad - Device has issues",
      memo: "Memo (Optional)",
      memoPlaceholder:
        "Please enter details about the device condition if any...",
      characterCount: "{{current}}/{{max}} characters",
      cancel: "Cancel",
      submit: "Submit Proxy Report",
      submitting: "Processing...",
    },
    reportResultBadge: {
      owned: {
        label: "Legitimate",
        description: "Device is properly managed",
      },
      lost: {
        label: "Lost",
        description: "Device is lost",
      },
      notKnown: {
        label: "Error",
        description: "Placement verification result is incorrect",
      },
    },
    footerDeviceInventory: {
      package: "Package: {{name}}",
      pattern: "Pattern: {{name}}",
      instances: "Active instances: {{count}} items",
    },
    dock: {
      reviewSelfReport: "Review self-report results",
      requestSelfReport: "Request self-report",
      selectAll: "Select all",
      startReview: "Start review",
      request: "Request",
      itemsSelected: "items selected",
      clearSelection: "Clear selection",
      complete: "Complete",
    },
    useColumns: {
      device: "Device",
      responsibleOwner: "Inventory Staff",
      selfReportDate: "Self-Report Date",
      reportResult: "Report Result",
      displayStatus: "Progress Status",
      statusReport: "Status Report",
      memo: "Memo",
      unassigned: "Unassigned",
      unreported: "Unreported",
      deviceConditionGood: "Good",
      deviceConditionBad: "Bad",
      deviceConditionUnreported: "Unreported",
      actions: "Actions",
      reportProxy: "Report Proxy",
    },
    deviceInventoryOperationData: {
      reportProxyError: "Report proxy failed",
      reportProxySuccess: "Report proxy completed successfully",
      completeReview: "Complete Review",
      requestSelfReport: "Request Self-Report",
      complete: "Complete",
      request: "Request",
    },
    errorHandling: {
      deviceNotFound: "Device not found",
      inventoryInProgress: "Inventory process is in progress",
      reportAlreadySubmitted: "Report has already been submitted",
      invalidStatusTransition: "Invalid status transition",
    },
    errorDisplay: {
      defaultTitle: "Failed to load data",
      defaultMessage: "Please try again after a while",
    },
    operationDataTable: {
      dock: {
        itemsSelected: "items selected",
        clearSelection: "Clear selection",
        selectAll: "Select all",
        currentPageSelected: "Selected {{count}} items on this page.",
        selectAllPages: "Select all {{count}} items",
      },
    },
  },
};

export default en;
